<template>
    <v-row v-if="isReady" no-gutters class="standard-row">
        <v-row v-if="transactionId || isCopyDocument" align="center" no-gutters class="standard-row font-theme" :style="`padding: ${paddingBackToInboxBtn()}`">
            <a @click="backToInbox()">
                <svg width="6" height="12" viewBox="0 0 6 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 10.9653L1 5.98267L5 1" stroke="#2A2E3B" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span style="font-weight: 700; font-size: 18px;" class="ml-2 black--text">กลับหน้ากล่องเอกสาร</span>
            </a>
        </v-row>
        <v-row no-gutters class="standard-row" style="">
            <!-------------------------------------------------- Create card -------------------------------------------------->
            <v-col cols="12" sm="12" md="12" :lg="windowSize.x >= 1400 && transactionId? '': '12'">
                <div :class="transactionId && windowSize.x >= 1400? ('div-create-detail-1') : (transactionId? 'div-create-detail-2' : isCopyDocument? 'div-create-detail-2' :'div-create-detail')" v-resize="onResize">
                    <v-card class="standard-row external-card-detail">
                        <v-row align="center" no-gutters class="standard-row pt-0 pt-md-6 pb-6 pl-md-5 pr-md-13" style="border-bottom: 1px solid #AEAEAE;">
                            <v-col cols="12" md="auto" lg="auto" :class="windowSize.x >= 960? 'ml-6': 'd-flex justify-center mt-6'" align="center">
                                <svg width="34" height="37" viewBox="0 0 34 37" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-top: 6px;">
                                    <path d="M9 3.47656H3.66667C2.95942 3.47656 2.28115 3.73749 1.78105 4.20193C1.28095 4.66637 1 5.29629 1 5.95312V33.1952C1 33.852 1.28095 34.482 1.78105 34.9464C2.28115 35.4109 2.95942 35.6718 3.66667 35.6718H30.3333C31.0406 35.6718 31.7189 35.4109 32.219 34.9464C32.7191 34.482 33 33.852 33 33.1952V5.95312C33 5.29629 32.7191 4.66637 32.219 4.20193C31.7189 3.73749 31.0406 3.47656 30.3333 3.47656H25" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M17 13.3828V28.3808M25 20.8124H9M11.6667 1H22.3333C23.0406 1 23.7189 1.26092 24.219 1.72537C24.719 2.18981 25 2.81973 25 3.47656C25 4.13338 24.719 4.7633 24.219 5.22774C23.7189 5.69219 23.0406 5.95311 22.3333 5.95311H11.6667C10.9594 5.95311 10.2811 5.69219 9.78105 5.22774C9.28095 4.7633 9 4.13338 9 3.47656C9 2.81973 9.28095 2.18981 9.78105 1.72537C10.2811 1.26092 10.9594 1 11.6667 1V1Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-col>
                            <v-col cols="12" md="auto" lg="auto" class="font-theme font-create-header" :class="windowSize.x >= 960? 'ml-7': 'd-flex justify-center text-center'">
                                Create Purchase Requisition
                            </v-col>
                            <v-spacer></v-spacer>
                            <v-col v-if="transactionDetail.document_id && transactionId" cols="12" md="auto" lg="auto" style="font-size: 20px; font-weight: 400;" class="pt-4 pt-md-0 text-center">
                                {{ transactionDetail.document_id }}
                            </v-col>
                        </v-row>
                        <v-form lazy-validation ref="headerForm">
                            <v-row no-gutters class="standard-row font-theme pb-11" style="border-bottom: 1px solid #AEAEAE;">
                                <v-col cols="12" sm="12" md="9" lg="9" style="padding-left: 4.5%;" class="mt-11" align-self="center">
                                    <v-row no-gutters class="standard-row" align="start">
                                        <v-col cols="12" sm="12" md="6" lg="6">
                                            <v-row no-gutters class="standard-row" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    ผู้ขอซื้อ
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.employee_id.name? false :true : transactionDetail.buyer.full_name_th? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined readonly v-bind="attrs" v-on="on" v-model="purchaseData.employee_id.name" height="31px" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.employee_id.name: transactionDetail.buyer.full_name_th }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    ส่วนงาน
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.section? false :true : transactionDetail.section? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined readonly v-bind="attrs" v-on="on" v-model="purchaseData.section" height="31px" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.section" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.section: transactionDetail.section }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    หน่วยงาน
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.department? false :true : transactionDetail.department? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.department" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.department" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.department: transactionDetail.department }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    ประเภทเอกสาร PR
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.document_type.name? false :true : transactionDetail.document_type_name? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-select v-if="!transactionId || resendStatus" :items="documentType" v-bind="attrs" v-on="on" v-model="purchaseData.document_type" hide-details item-text="name" outlined dense height="31" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" :rules="[ v => !!v && !!v.name && !!v.pr_id && !!v._id ]" required return-object>
                                                                <template v-slot:item="data">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px;">{{ data.item.name }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </template>
                                                                <template v-slot:no-data>
                                                                    <v-list-item>
                                                                        <v-list-item-content>
                                                                            <v-list-item-title class="font-theme" style="line-height: 30px;">ไม่พบข้อมูล</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-select>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.document_type_name" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.document_type.name :transactionDetail.document_type_name }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    PR ID
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.document_type.pr_id? false :true : transactionDetail.pr_id? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined height="31px" v-bind="attrs" v-on="on" v-model="purchaseData.document_type.pr_id" readonly color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.pr_id" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.document_type.pr_id :transactionDetail.pr_id }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    Cost Sheet / SO
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.cs_memo? false :true : transactionDetail.cs_memo? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.cs_memo" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.cs_memo" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.cs_memo :transactionDetail.cs_memo }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    QT Number
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.qt_number? false :true : transactionDetail.qt_number? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.qt_number" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.qt_number" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.qt_number :transactionDetail.qt_number }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                     Project
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.project? false :true : transactionDetail.project? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details="auto" outlined v-bind="attrs" v-on="on" v-model="purchaseData.project" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="[...textRules, ...maxChars200]" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.project" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.project :transactionDetail.project }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="start">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="start">
                                                    คำอธิบายเพิ่มเติม
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 5%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.description? false :true : transactionDetail.description? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-textarea v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.description" rows="3" color="black" class="py-0 font-theme border-radius-box text-area-description"></v-textarea>
                                                            <v-textarea v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.description" rows="3" color="black" class="py-0 font-theme border-radius-box text-area-description"></v-textarea>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.description :transactionDetail.description }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row v-if="selectedBiz.tax_id === '0107544000094'" no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    Ref.Po
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.ref_po? false :true : transactionDetail.ref_po? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.ref_po" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.ref_po" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.ref_po :transactionDetail.ref_po }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                        <v-col cols="12" sm="12" md="6" lg="6" class="mt-4 mt-md-0">
                                            <v-row no-gutters class="standard-row" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    Company Code
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.company.company_code? false :true : transactionDetail.company.company_code? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined readonly v-bind="attrs" v-on="on" v-model="purchaseData.company.company_code" height="31px" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.company.company_code" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.company.company_code :transactionDetail.company.company_code }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    Company Name
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.company.company_name? false :true : transactionDetail.company.company_name? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined readonly v-bind="attrs" v-on="on" v-model="purchaseData.company.company_name" height="31px" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.company.company_name" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.company.company_name :transactionDetail.company.company_name }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    ความต้องการสินค้า
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.requirement? false :true : transactionDetail.requirement? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-select v-if="!transactionId || resendStatus" :items="permissionShowRowSignNo2 === true ? demandGoodsDropdownBizInet : demandGoodsDropdown" v-bind="attrs" v-on="on" v-model="purchaseData.requirement" @change="getShowRowSignNo2()" hide-details outlined dense height="31" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" :rules="textRules" required>
                                                                <template v-slot:item="data">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px;">{{ data.item }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </template>
                                                            </v-select>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.requirement" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.requirement :transactionDetail.requirement }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    วันที่เริ่มต้น
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? startDateShow? false :true : startDateDetailShow? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-menu v-if="!transactionId || resendStatus" offset-y v-model="startDateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field dense hide-details outlined readonly clearable v-on="on" height="31px" v-bind="attrs" :value="startDateShow" color="black" class="font-theme border-radius-box clear-icon-margin" @click:clear="purchaseData.start_date = null" :rules="textRules" required></v-text-field>
                                                                </template>
                                                                <v-date-picker color="#0B68D6" no-title v-model="purchaseData.start_date" show-current locale="th" @input="startDateMenu = false" :max="purchaseData?.end_date || ''" class="font-theme detail-date-picker-create-purchase"></v-date-picker>
                                                            </v-menu>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="startDateDetailShow" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? startDateShow :startDateDetailShow }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    วันที่สิ้นสุด
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? endDateShow? false :true : endDateDetailShow? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-menu v-if="!transactionId || resendStatus" offset-y v-model="endDateMenu" min-width="auto" :close-on-content-click="false" transition="scale-transition">
                                                                <template v-slot:activator="{ on }">
                                                                    <v-text-field dense hide-details outlined readonly clearable v-on="on" v-bind="attrs" height="31px" :value="endDateShow" color="black" class="font-theme border-radius-box clear-icon-margin" @click:clear="purchaseData.end_date = null" :rules="textRules" required></v-text-field>
                                                                </template>
                                                                <v-date-picker color="#0B68D6" no-title v-model="purchaseData.end_date" show-current locale="th" @input="endDateMenu = false" :min="purchaseData?.start_date || ''" class="font-theme detail-date-picker-create-purchase"></v-date-picker>
                                                            </v-menu>
                                                            <v-text-field v-else hide-details outlined readonly v-on="on" v-bind="attrs" v-model="endDateDetailShow" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? endDateShow :endDateDetailShow }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    ปีเอกสาร
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.document_year? false :true : transactionDetail.document_year? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details readonly outlined height="31px" v-on="on" v-bind="attrs" v-model="purchaseData.document_year" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-on="on" v-bind="attrs" v-model="transactionDetail.document_year" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.document_year :transactionDetail.document_year }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    แผนกขอซื้อ
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.department_to_buy? false :true : transactionDetail.department_to_buy? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined height="31px" v-bind="attrs" v-on="on" v-model="purchaseData.department_to_buy" color="black" class="py-0 font-theme border-radius-box margin-left-text-field" :rules="textRules" required></v-text-field>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.department_to_buy" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.department_to_buy :transactionDetail.department_to_buy }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row mt-4" align="center">
                                                <v-col cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    Owner
                                                </v-col>
                                                <v-col cols="12" sm="8" md="12" lg="8" align-self="center" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.owner: transactionDetail.owner)">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.owner" :items="searchOwnerList" append-icon="" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.owner)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.owner = $event.srcElement.value; searchOwnerList = []; statusSearchingOwner = ''" return-object :rules="typeof purchaseData.owner === 'string'? [v => !!v]: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('owner')">
                                                                <template v-slot:append>
                                                                    <v-icon class="mr-1" style="margin-top: 2px;" @click="searchCitizen(purchaseData.owner)">mdi-account-search</v-icon>
                                                                </template>
                                                                <template v-slot:item="data">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </template>
                                                                <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                                    <v-list-item>
                                                                        <v-list-item-content>
                                                                            <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </v-list-item>
                                                                </template>
                                                            </v-combobox>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.owner.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.owner: transactionDetail.owner) }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                            <v-row no-gutters class="standard-row" align="center">
                                                <v-radio-group v-if="!transactionId || resendStatus" hide-details row v-model="purchaseData.special_procurement_type" :rules="[ v => v !== null && v !== undefined  ]" required>
                                                    <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">จัดซื้อจัดจ้างปกติ</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">จัดซื้อจัดจ้างพิเศษ</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                                <v-radio-group v-else hide-details row v-model="transactionDetail.special_procurement_type" readonly>
                                                    <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">จัดซื้อจัดจ้างปกติ</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">จัดซื้อจัดจ้างพิเศษ</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-row>
                                            <v-row no-gutters class="standard-row" align="center">
                                                <v-radio-group v-if="!transactionId || resendStatus" hide-details row v-model="purchaseData.has_memo" :rules="[ v => v !== null && v !== undefined  ]" required>
                                                    <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">มี Memo</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">ไม่มี Memo</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                                <v-radio-group v-else hide-details row v-model="transactionDetail.has_memo" readonly>
                                                    <v-radio class="font-theme" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">มี Memo</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text">ไม่มี Memo</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-row>
                                           <v-row no-gutters class="standard-row custom-row-license" align="center">
                                                <v-col class="custom-title-license" cols="12" sm="4" md="12" lg="4" align-self="center">
                                                    <v-row justify="start" align="center" no-gutters>
                                                        <v-col class="custom-layout" cols="auto" sm="auto">
                                                            <v-checkbox
                                                                v-if="!transactionId || resendStatus"
                                                                v-model="purchaseData.has_license"
                                                                :true-value="true"
                                                                :false-value="false"
                                                                hide-details
                                                                color="#D9D9D9"
                                                                on-icon="mdi-checkbox-marked"
                                                                off-icon="mdi-checkbox-blank-outline"
                                                                :ripple="false"
                                                                class="py-0 mr-4 font-theme"
                                                                density="compact"
                                                                >
                                                                <template v-slot:label>
                                                                    <span class="black--text">License</span>
                                                                </template>
                                                            </v-checkbox>
                                                            <v-checkbox
                                                                v-else
                                                                readonly
                                                                v-model="transactionDetail.has_license"
                                                                hide-details
                                                                color="#D9D9D9"
                                                                on-icon="mdi-checkbox-marked"
                                                                off-icon="mdi-checkbox-blank-outline"
                                                                :ripple="false"
                                                                class="py-0 mr-4 font-theme"
                                                                density="compact"
                                                                >
                                                                <template v-slot:label>
                                                                    <span class="black--text">License</span>
                                                                </template>
                                                            </v-checkbox>
                                                        </v-col>
                                                        <v-col class="custom-layout" cols="auto" sm="auto" lg="12">
                                                            <v-checkbox  
                                                                v-if="(purchaseData.has_license === true && ['Fortigate','Palo'].includes(purchaseData.license)) && (!transactionId || resendStatus)"
                                                                v-model="purchaseData.renew"
                                                                :true-value="true"
                                                                :false-value="false"
                                                                hide-details
                                                                color="#D9D9D9"
                                                                on-icon="mdi-checkbox-marked"
                                                                off-icon="mdi-checkbox-blank-outline"
                                                                :ripple="false"
                                                                class="renew-checkbox py-0 mr-2 font-theme"
                                                                density="compact"
                                                            >
                                                                <template v-slot:label>
                                                                    <span class="black--text">Renew</span>
                                                                </template>
                                                            </v-checkbox>
                                                            <v-checkbox 
                                                                v-else-if="transactionDetail.has_license === true && ['Fortigate','Palo'].includes(transactionDetail.license)"
                                                                v-model="transactionDetail.renew"
                                                                color="#D9D9D9"
                                                                on-icon="mdi-checkbox-marked"
                                                                off-icon="mdi-checkbox-blank-outline"
                                                                :ripple="false"
                                                                class="renew-checkbox py-0 mr-2 font-theme"
                                                                density="compact"
                                                                hide-details
                                                                readonly
                                                            >
                                                                <template v-slot:label>
                                                                    <span class="black--text">Renew</span>
                                                                </template>
                                                            </v-checkbox>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col class="fade-left-to-right custom-layout-license" v-if="purchaseData.has_license === true || transactionDetail.has_license  === true" cols="12" sm="8" md="12" lg="8" align-self="baseline" :style="windowSize.x < 960? 'padding-right: 4.5%;': 'padding-right: 10%;'">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.license? false :true : transactionDetail.license? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-select v-if="!transactionId || resendStatus" :items="licenseDropdown" v-bind="attrs" v-on="on" v-model="purchaseData.license" hide-details outlined dense height="31" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown mt-4" :rules="textRules" required>
                                                                <template v-slot:item="data">
                                                                    <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px;">{{ data.item }}</v-list-item-title>
                                                                    </v-list-item-content>
                                                                </template>
                                                            </v-select>
                                                            <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.license" height="31px" color="black" class="py-0 mt-4 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.license: transactionDetail.license }}</span>
                                                    </v-tooltip>
                                                </v-col>
                                            </v-row>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="3" lg="3" class="d-flex flex-column mt-4 mt-md-0" style="padding-right: 4.5%;" :style="{ 'padding-left' : windowSize.x < 960? '4.5%' :'', 'gap' : customHeight }">
                                   <v-row no-gutters class="standard-row font-theme mt-11 d-flex justify-center order-3 order-md-1" align="center" style="flex: 0;">
                                        <v-col cols="auto" sm="auto" md="12" lg="auto" class="text-right mt-7 pr-lg-2">
                                            <img width="70" src="../assets/coin_image.png" />
                                        </v-col>
                                        <v-col cols="8" sm="6" md="12" lg="">
                                            <v-row no-gutters class="standard-row" align="center">
                                                <v-col cols="12" sm="12" md="12" lg="12" style="font-weight: 700; font-size: 12px;">
                                                    Total Value PR
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" lg="12">
                                                    <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.total_price? false :true : transactionDetail.total_price? false :true">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-text-field v-if="!transactionId || resendStatus" hide-details outlined v-bind="attrs" v-on="on" v-model="purchaseData.total_price" height="64" readonly type="text" color="black" background-color="#EAEAEA" class="py-0 font-theme border-radius-box margin-left-text-field text-field-right total-value-pr-create-doc" style="font-size: 25px;"></v-text-field>
                                                            <v-text-field v-else hide-details outlined height="64" readonly v-bind="attrs" v-on="on" v-model="transactionDetail.total_price" type="text" color="black" class="py-0 font-theme border-radius-box margin-left-text-field text-field-right total-value-pr-create-doc" style="font-size: 25px;"></v-text-field>
                                                        </template>
                                                        <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.total_price :transactionDetail.total_price }}</span>
                                                    </v-tooltip>
                                                    <div>
                                                        <div v-if="!transactionId || resendStatus" >
                                                            <h5  style="text-align: right;">{{subCurrency}}</h5>
                                                        </div>
                                                        <div v-else>
                                                            <h5 v-if ="transactionDetail.products?.[0]?.currency == 'ยูโร European euro' || purchaseData.products?.[0]?.currency  == 'ยูโร European euro'" style="text-align: right;">EUR</h5>
                                                            <h5 v-else-if ="transactionDetail.products?.[0]?.currency == 'ดอลลาร์ออสเตรเลีย' || purchaseData.products?.[0]?.currency == 'ดอลลาร์ออสเตรเลีย'" style="text-align: right;">AUD</h5>
                                                            <h5 v-else-if ="transactionDetail.products?.[0]?.currency == 'ดอลลาร์สิงคโปร์' || purchaseData.products?.[0]?.currency == 'ดอลลาร์สิงคโปร์'" style="text-align: right;">SGD</h5>
                                                            <h5 v-else-if ="transactionDetail.products?.[0]?.currency == 'ดอลลาร์สหรัฐ' || purchaseData.products?.[0]?.currency == 'ดอลลาร์สหรัฐ'" style="text-align: right;">USD</h5>
                                                            <h5 v-else-if ="(transactionDetail.products?.[0]?.currency == 'หยวน' || purchaseData.products?.[0]?.currency == 'หยวน') && selectedBiz.tax_id === '0107544000094'" style="text-align: right;">CNY</h5>
                                                            <h5 v-else-if ="transactionDetail.products?.[0]?.currency  == 'บาท' || purchaseData.products?.[0]?.currency == 'บาท'" style="text-align: right;">THB</h5>
                                                        </div>
                                                    </div>                                                 
                                                </v-col>                                       
                                            </v-row>
                                        </v-col>
                                    </v-row>

                                    <!-------------------------------------------------------- Memo Number -------------------------------------------------------->
                                    <v-row justify="end" v-if="purchaseData.has_memo || transactionDetail.has_memo" no-gutters class="standard-row pr-lg-1 pr-3 order-4 order-md-2"  style="flex: 0; border-radius: 25px;">
                                        <v-btn  height="27px" color="#D9D9D9" class="black--text" style="font-size: 12px; padding: 2%" @click="downloadFile">
                                            <v-icon size="20" class="mr" color="#848484">
                                                mdi-file-pdf-box
                                            </v-icon>
                                            คู่มือการเพิ่มและดูเอกสารMEMO
                                        </v-btn>
                                    </v-row>
                                    <v-row v-if="purchaseData.has_memo || transactionDetail.has_memo" no-gutters class="fade-left-to-right standard-row font-theme pl-3 pr-lg-1 pr-3 order-2 order-md-3" style="flex: 0; border: 1px solid #A8A8A8; border-radius: 5px;">
                                        <v-row no-gutters class="standard-row font-theme mt-4" align="center">
                                            <v-col cols="6" sm="6" md="" :lg="windowSize.x >= 1443? '6': 'auto'">
                                                <v-row no-gutters class="standard-row font-theme" style="font-size: 11px;" align="center">
                                                    <v-col cols="auto" sm="auto" md="12" lg="12" style="line-height: 21px;">
                                                        Memo No.
                                                    </v-col>
                                                    <v-col cols="" sm="" md="12" lg="12" class="pr-lg-2 pl-sm-3 pl-md-0 pr-3 pr-md-0">
                                                        <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.memo_no? false :true : transactionDetail.memo_no? false :true">
                                                            <template v-slot:activator="{ on, attrs }">
                                                                <v-autocomplete v-if="!transactionId || resendStatus" :items="memoList" item-text="memo_no" v-bind="attrs" v-on="on" v-model="purchaseData.memo_no" hide-details outlined dense height="31" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" @change="memoData(purchaseData.memo_no)" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" :rules="textRules" required>
                                                                    <template v-slot:item="data">
                                                                        <v-list-item-content>
                                                                        <v-list-item-title class="font-theme" style="line-height: 30px;">
                                                                            {{ data.item.memo_no }}
                                                                        </v-list-item-title>
                                                                        </v-list-item-content>
                                                                    </template>
                                                                </v-autocomplete>
                                                                <v-text-field v-else v-bind="attrs" v-on="on" v-model="transactionDetail.memo_no" readonly hide-details outlined height="20" color="black" class="border-radius-box" style="font-size: 11px;"></v-text-field>
                                                            </template>
                                                            <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.memo_no :transactionDetail.memo_no }}</span>
                                                        </v-tooltip>
                                                    </v-col>
                                                </v-row>
                                            </v-col>
                                            <v-col cols="6" sm="6" md="auto" :lg="windowSize.x >= 1443? '6': 'auto'">
                                                <v-radio-group v-if="!transactionId || resendStatus" hide-details :readonly="purchaseDataMeMo.in_budget !== null ? true : false" v-model="purchaseData.in_budget" :rules="[ v => v !== null && v !== undefined  ]" required row class="mt-0">
                                                    <v-radio class="font-theme radio-memo-create mr-1" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text" style="font-size: 12px;">ในงบประมาณ</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme radio-memo-create mr-1" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text" style="font-size: 12px;">นอกงบประมาณ</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                                <v-radio-group v-else hide-details row v-model="transactionDetail.in_budget" readonly class="mt-0">
                                                    <v-radio class="font-theme radio-memo-create mr-1" :value="true" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text" style="font-size: 12px;">ในงบประมาณ</span>
                                                        </template>
                                                    </v-radio>
                                                    <v-radio class="font-theme radio-memo-create mr-1" :value="false" color="#D9D9D9" on-icon="mdi-checkbox-marked" off-icon="mdi-checkbox-blank-outline" :ripple="false">
                                                        <template v-slot:label>
                                                            <span class="black--text" style="font-size: 12px;">นอกงบประมาณ</span>
                                                        </template>
                                                    </v-radio>
                                                </v-radio-group>
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="standard-row font-theme pr-lg-2 mt-5" align="center">
                                            <v-col cols="5" sm="5" md="12" lg="auto" style="font-size: 12px;">
                                                งบประมาณ Memo
                                            </v-col>
                                            <v-col cols="5" sm="5" md="" lg="" class="pr-2" :style="windowSize.x >= 1264? 'padding-left: 9px;': ''">
                                                <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.memo_budget? false :true : transactionDetail.memo_budget? false :true">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-if="(!transactionId || resendStatus)" v-model="purchaseData.memo_budget" readonly filled v-bind="attrs" v-on="on" hide-details @keyup="calculateCost(purchaseData.products[0])" outlined height="20" color="black" class="border-radius-box in-budget-memo-input" style="font-size: 11px;" :rules="textRules" required v-currency="{ distractionFree: false, currency: null, allowNegative: false }"></v-text-field>
                                                        <v-text-field v-else v-model="transactionDetail.memo_budget" readonly v-bind="attrs" v-on="on" hide-details outlined height="20" color="black" class="border-radius-box" style="font-size: 11px;"></v-text-field>
                                                    </template>
                                                    <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.memo_budget :transactionDetail.memo_budget }}</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 12px;">
                                                {{ transactionDetail.memo_currency || purchaseData.memo_currency || 'บาท' }}
                                            </v-col>
                                        </v-row>
                                        <v-row no-gutters class="standard-row font-theme pr-lg-2 mt-2 mb-5" align="center">
                                            <v-col cols="5" sm="5" md="12" lg="auto" style="font-size: 12px;">
                                                งบประมาณ คงเหลือ
                                            </v-col>
                                            <v-col cols="5" sm="5" md="" lg="" class="pl-lg-2 pr-2">
                                                <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.remaining_budget? false :true : transactionDetail.remaining_budget? false :true">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-if="!transactionId || resendStatus" readonly filled v-model="purchaseData.remaining_budget" :error="purchaseData.remaining_budget < 0" v-bind="attrs" v-on="on" hide-details outlined height="20" color="black" class="border-radius-box in-budget-memo-input" style="font-size: 11px;"></v-text-field>
                                                        <v-text-field v-else v-model="transactionDetail.remaining_budget" readonly v-bind="attrs" v-on="on" hide-details outlined height="20" color="black" class="border-radius-box" style="font-size: 11px;"></v-text-field>
                                                    </template>
                                                    <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.remaining_budget :transactionDetail.remaining_budget }}</span>
                                                </v-tooltip>
                                            </v-col>
                                            <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 12px;">
                                                {{ transactionDetail.memo_currency || purchaseData.memo_currency || 'บาท' }}
                                            </v-col>
                                        </v-row>
                                    </v-row>
                                    <v-row v-if="showTextfieldSerialNum"  style="flex: 0;" class="custom-row-serial-num standard-row font-theme mt-auto mb-4 mb-md-0 order-1 order-md-4" no-gutters>
                                        <v-col cols="12" class="fade-left-to-right custom-serial-num" :class="customAlignSerialNum" :style="{ 'height' : customHeightSerialNum }">
                                            <v-tooltip top :disabled="(!transactionId || resendStatus)? purchaseData.serial_number? false :true : transactionDetail.serial_number? false :true">
                                                <template v-slot:activator="{ on, attrs}">
                                                    <v-text-field v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.serial_number" class="font-theme border-radius-box margin-left-text-field field-serial-num mt-sm-0 py-0" :class="customMarginSerialNum" height="31px" color="black" :rules="textRules" placeholder="S/N (Serial Number)" hide-details outlined required></v-text-field>
                                                    <v-text-field v-else v-bind="attrs" v-on="on" v-model="transactionDetail.serial_number" class="font-theme border-radius-box margin-left-text-field field-serial-num mt-sm-0 py-0" :class="customMarginSerialNum" height="31px" color="black" hide-details outlined readonly></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ (!transactionId || resendStatus)? purchaseData.serial_number :transactionDetail.serial_number }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
                        <!------------------------------------------------- product list ------------------------------------------------->
                        <v-row v-if="!transactionId || resendStatus" no-gutters class="standard-row" align="center" style="padding: 18px 4.5% 10px 4.5%">
                            <v-btn large color="#0B68D6" class="custom-login-btn font-theme white--text" height="34px"  @click="addMoreProducts()" style="font-weight: 700; font-size: 20px; border-radius: 4px; box-shadow: none;">
                                รายการสินค้า
                                <svg class="ml-3" width="20" height="18" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 10H16M11 19C16.5475 19 21 15.0333 21 10.0405C21 5.04775 16.5475 1 11 1C5.4525 1 1 5.04775 1 10.0405C1 15.0333 5.4525 19 11 19ZM11 14.563V5.5V14.563Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </v-btn>
                        </v-row>
                        <v-form lazy-validation ref="productForm">
                            <v-row no-gutters style="border-bottom: 1px solid #AEAEAE;" class="standard-row pb-9" :class="{ 'pt-9': transactionId }">
                                <v-row
                                    no-gutters
                                    class="standard-row font-theme product-list-row"
                                    align="center"
                                    v-for="(listProduct, indexProduct) in transactionId && !resendStatus
                                        ? transactionDetail.products
                                        : purchaseData.products"
                                    :key="listProduct.id_list"
                                >
                                    <ProductsCard
                                        ref="ProductsCard"
                                        @request-gl-account="handleRequestGlAccount"
                                        @send-product-price="receiveProductData"
                                        @conjunct-product="connectSomeProductData"
                                        :indexProduct="indexProduct"
                                        :productDetail="
                                        transactionId && !resendStatus
                                            ? listProduct
                                            : {
                                                ...listProduct,
                                                vendor: purchaseData.products[0].vendor,
                                                budget_type: purchaseData.products[0].budget_type,
                                            }
                                        "
                                        :editStatus="!transactionId || resendStatus"
                                        :isSameAllCurrency="isSameAllCurrency"
                                        :deleteProduct="deleteProduct"
                                        :isProductOnlyOne="purchaseData.products.length === 1"
                                        :dynamicItemDropdown="{
                                            documentType,
                                            goodsList,
                                            vendorList,
                                            costCenterList,
                                            unitList,
                                        }"
                                        @sendMaterialId="handleMaterialId"
                                        :isCopyDocument="isCopyDocument"
                                    />
                                </v-row>
                            </v-row>
                        </v-form>
                        <!------------------------------------------------- boarder list ------------------------------------------------->
                        <v-col><h5 style="text-align: right; margin-right: 0;"  class="red-text">*ระบุเฉพาะชื่อและนามสกุลเท่านั้น</h5></v-col>
                        <v-form lazy-validation ref="boarderForm">
                            <v-row no-gutters class="standard-row font-theme mt-5" align="center" style="padding: 0% 5.7% 0% 5.7%;">
                                <v-col cols="12" sm="12" md="6" lg="6">
                                  <v-row v-if="showRowSignNo4" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            คณะกรรมการตรวจรับ 
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.sign_no4 : transactionDetail.buyer_board.supply_board1.full_name_th)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox
                                                        v-if="!transactionId || resendStatus"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-model="purchaseData.buyer_board.sign_no4"
                                                        :items="searchOwnerList"
                                                        item-text="full_name_th"
                                                        hide-details
                                                        outlined
                                                        dense
                                                        height="31"
                                                        item-color="#D9D9D9"
                                                        color="black"
                                                        :menu-props="{ bottom: true, offsetY: true }"
                                                        class="font-theme detail-dropdown"
                                                        @keyup.enter="searchCitizen(purchaseData.buyer_board.sign_no4)"
                                                        @mouseup="searchOwnerList = [], statusSearchingOwner = ''"
                                                        @input.native="purchaseData.buyer_board.sign_no4 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''"
                                                        return-object
                                                        :rules="typeof purchaseData.buyer_board.sign_no4 === 'string'  ? textRules  : [ v => !!v && !!v.account_id && !!v.thai_email ]"
                                                        required
                                                        :error="errorCheckName('sign_no4')"
                                                    >
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.sign_no4)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field
                                                        v-else
                                                        hide-details
                                                        outlined
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        v-model="transactionDetail.buyer_board.supply_board1.full_name_th"
                                                        height="31px"
                                                        color="black"
                                                        class="py-0 font-theme border-radius-box margin-left-text-field"
                                                    ></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.sign_no4?.full_name_th : transactionDetail.buyer_board.supply_board1.full_name_th) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                  </v-row>
                                    <v-row v-if="buyerBoardShowRow" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            หัวหน้ากลุ่มงานขอซื้อ
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.head_to_buy: transactionDetail.buyer_board.head_to_buy)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.head_to_buy" :items="searchOwnerList" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.head_to_buy)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.head_to_buy = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.head_to_buy === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('head_to_buy')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.head_to_buy)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.head_to_buy.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme mt-5" align="center" style="padding: 0% 5.7% 0% 5.7%;">
                                <v-col cols="12" sm="12" md="6" lg="6">
                                    <v-row v-if="buyerBoardShowRow" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            คณะกรรมการจัดหา 1
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.supply_board1: transactionDetail.buyer_board.supply_board1)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.supply_board1" :items="searchOwnerList" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.supply_board1)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.supply_board1 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.supply_board1 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('supply_board1')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.supply_board1)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.supply_board1.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" class="mt-5 mt-md-0">
                                    <v-row v-if="buyerBoardShowRow" no-gutters class="standard-row" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5" class="pl-md-5">
                                            คณะกรรมการจัดหา 2
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-5">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.supply_board2: transactionDetail.buyer_board.supply_board2)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.supply_board2" :items="searchOwnerList" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.supply_board2)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.supply_board2 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.supply_board2 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('supply_board2')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.supply_board2)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.supply_board2.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row no-gutters class="standard-row font-theme mt-5" align="center" style="padding: 0% 5.7% 0% 5.7%;">
                                <v-col cols="12" sm="12" md="6" lg="6">
                                    <v-row v-if="showRowSignNo2" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            คณะกรรมการตรวจรับงาน 1
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.check_board1" :items="searchOwnerList" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.check_board1)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.check_board1 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.check_board1 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('check_board1')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.check_board1)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.check_board1.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="buyerBoardShowRow" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            คณะกรรมการตรวจรับ 1
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.check_board1" :items="searchOwnerList" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.check_board1)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.check_board1 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.check_board1 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('check_board1')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.check_board1)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.check_board1.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board1: transactionDetail.buyer_board.check_board1) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" sm="12" md="6" lg="6" class="mt-5 mt-md-0">
                                    <v-row v-if="buyerBoardShowRow" no-gutters class="standard-row" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5" class="pl-md-5">
                                            คณะกรรมการตรวจรับ 2
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7" class="pl-md-5">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board2: transactionDetail.buyer_board.check_board2)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.check_board2" :items="searchOwnerList" append-icon="" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.check_board2)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.check_board2 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.check_board2 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('check_board2')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.check_board2)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.check_board2.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board2: transactionDetail.buyer_board.check_board2) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                    <v-row v-if="showRowSignNo2" no-gutters class="standard-row pr-md-5" align="center">
                                        <v-col cols="12" sm="5" md="12" lg="5">
                                            คณะกรรมการตรวจรับงาน 2
                                        </v-col>
                                        <v-col cols="12" sm="7" md="12" lg="7">
                                            <v-tooltip top :disabled="disableTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board2: transactionDetail.buyer_board.check_board2)">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-combobox v-if="!transactionId || resendStatus" v-bind="attrs" v-on="on" v-model="purchaseData.buyer_board.check_board2" :items="searchOwnerList" append-icon="" item-text="full_name_th" hide-details outlined dense height="31" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" class="font-theme detail-dropdown" @keyup.enter="searchCitizen(purchaseData.buyer_board.check_board2)" @mouseup="searchOwnerList = [], statusSearchingOwner = ''" @input.native="purchaseData.buyer_board.check_board2 = $event.srcElement.value, searchOwnerList = [], statusSearchingOwner = ''" return-object  :rules="typeof purchaseData.buyer_board.check_board2 === 'string'? textRules: [ v => !!v && !!v.account_id && !!v.thai_email]" required :error="errorCheckName('check_board2')">
                                                        <template v-slot:append>
                                                            <v-icon class="mr-1" style="margin-top: 3px;" @click="searchCitizen(purchaseData.buyer_board.check_board2)">mdi-account-search</v-icon>
                                                        </template>
                                                        <template v-slot:item="data">
                                                            <v-list-item-content>
                                                                <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ data.item.full_name_th }}</v-list-item-title>
                                                            </v-list-item-content>
                                                        </template>
                                                        <template v-slot:no-data v-if="statusSearchingOwner.length > 0">
                                                            <v-list-item>
                                                                <v-list-item-content>
                                                                    <v-list-item-title class="font-theme" style="line-height: 30px; font-size: 16px;">{{ statusSearchingOwner }}</v-list-item-title>
                                                                </v-list-item-content>
                                                            </v-list-item>
                                                        </template>
                                                    </v-combobox>
                                                    <v-text-field v-else hide-details outlined readonly v-bind="attrs" v-on="on" v-model="transactionDetail.buyer_board.check_board2.full_name_th" height="31px" color="black" class="py-0 font-theme border-radius-box margin-left-text-field"></v-text-field>
                                                </template>
                                                <span class="font-theme">{{ showNameCitizenTooltip((!transactionId || resendStatus)? purchaseData.buyer_board.check_board2: transactionDetail.buyer_board.check_board2) }}</span>
                                            </v-tooltip>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-form>
    
                        <!------------------------------------------------- button Zone ------------------------------------------------->
                        <v-row no-gutters class="standard-row browse-file-approve-doc-btn d-flex justify-end" align="center">
                            <div v-if="showUploadFileButton()" :class="windowSize.x < 600? 'text-center': ''">
                                <v-btn height="49" width="131" color="#0B68D6" @click="uploadAttachFile()" class="browse-file-btn ml-2 font-theme white--text" style="border-radius: 11px; box-shadow: none; font-size: 20px; font-weight: 700;">
                                    <svg class="mr-2" width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M23.8808 8.58012C23.8814 8.08193 23.8015 7.58847 23.6455 7.12798C23.4895 6.6675 23.2606 6.24901 22.9719 5.89647C22.6831 5.54393 22.3402 5.26425 21.9626 5.07342C21.5851 4.8826 21.1805 4.78438 20.7718 4.78438L12.9992 4.79006L9.89023 1H3.67219C3.2599 1 2.86451 1.19965 2.57298 1.55504C2.28145 1.91043 2.11768 2.39244 2.11768 2.89503V8.58012" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M1.04504 10.9335L3.083 20.8692C3.25113 21.6891 3.63924 22.417 4.18566 22.9372C4.73208 23.4574 5.40545 23.74 6.09875 23.7402H19.8981C20.5914 23.74 21.2648 23.4574 21.8112 22.9372C22.3576 22.417 22.7458 21.6891 22.9139 20.8692L24.9534 10.9297C25.0108 10.6503 25.0152 10.3586 24.9663 10.0768C24.9174 9.795 24.8164 9.53049 24.671 9.3034C24.5256 9.07631 24.3397 8.89261 24.1274 8.76625C23.915 8.6399 23.6818 8.57423 23.4455 8.57422L2.55447 8.5799C2.31817 8.57991 2.08499 8.64559 1.87264 8.77194C1.66029 8.89829 1.47437 9.082 1.329 9.30909C1.18362 9.53618 1.08263 9.80068 1.0337 10.0825C0.984765 10.3643 0.989175 10.656 1.04659 10.9354L1.04504 10.9335Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                    </svg>
                                        ไฟล์แนบ
                                </v-btn>
                            </div>
                            <div v-if="!transactionId || resendStatus">
                                <v-btn height="49" width="172" color="#0B68D6" @click="confirmCreate()" style="border-radius: 11px; font-size: 20px; font-weight: 700; box-shadow: none;" class="ml-2 font-theme white--text">
                                    ส่งอนุมัติเอกสาร
                                </v-btn>
                            </div>
                        </v-row>
                        <ConfirmCreatePurchaseModal />
                        <UploadAttachFile />
                        <saveBudgetModal />
                    </v-card>
                </div>
            </v-col>
    
            <!-------------------------------------------------- Confirm card -------------------------------------------------->
            <v-col v-if="transactionId" cols="12" sm="" md="" :lg="windowSize.x >= 1400? '3': '12'" style="z-index: 1;">
                <div :class="windowSize.x < 1400? 'div-check-document-1':'div-check-document'">
                    <v-card class="standard-row external-card-detail-1">
                        <v-row class="standard-row ml-4" style="padding-top: 25px;">
                            <svg width="34" height="30" viewBox="0 0 34 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.45976 15.0882C4.43794 11.6881 5.67811 8.39649 7.94875 5.82776C10.2194 3.25902 13.3653 1.58875 16.7992 1.12875C20.2331 0.668751 23.7203 1.45047 26.6098 3.32796C29.4993 5.20546 31.5936 8.05041 32.5017 11.3317C33.4098 14.613 33.0696 18.1064 31.5448 21.1597C30.0199 24.2131 27.4145 26.6176 24.215 27.9245C21.0155 29.2314 17.4405 29.3513 14.1575 28.2619C10.8744 27.1725 8.10768 24.9481 6.37377 22.0041" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M4.4595 20.2509L8.91899 15.0009H0L4.4595 20.2509Z" fill="black"/>
                                <path d="M18.7299 8.00085V16.7508H24.0813" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                            <span class="font-theme" style="font-size: 20px; margin-left: 10px;">ตรวจสอบเอกสาร</span>
                        </v-row>
                        <v-row class="standard-row" style="padding-top: 33px; margin-left: 0.5%; padding-bottom: 83px;">
                            <v-timeline dense align-top class="pt-0 standard-row pb-5 time-line-detail" style="padding-right: 7%;">
                                <v-timeline-item small right color="transparent" v-for="(flow, indexFlow) in transactionDetail.flow_step" :key="`flow${flow}${indexFlow}`" class="doc-detail-each-step pb-0">
                                    <template v-if="transactionDetail.document_status.toLowerCase() ==='c'" v-slot:icon>
                                        <v-icon color="#BDBDBD" size="36">mdi-cancel</v-icon>
                                    </template>
                                    <template v-else v-slot:icon>
                                        <v-icon v-if="flow.status.toLowerCase() === 'w'" color="#EEC120" size="36">mdi-clock-outline</v-icon>
                                        <v-icon v-else-if="flow.status.toLowerCase() === 'y'" color="#1BDE3A" size="36">mdi-check-circle-outline</v-icon>
                                        <v-icon v-else-if="flow.status.toLowerCase() === 'r'" color="#E08D8D" size="36">mdi-close-circle-outline</v-icon>
                                        <v-icon v-else-if="flow.status.toLowerCase() === 'n' && transactionDetail.flow_step.some(e => e.status.toLowerCase() === 'r')" color="#E08D8D" size="36">mdi-circle-slice-8</v-icon>
                                        <v-icon v-else-if="flow.status.toLowerCase() === 'n'" color="#AEAEAE" size="36">mdi-clock-outline</v-icon>
                                    </template>
                                    <v-row class="standard-row font-theme d-flex justify-space-between" style="font-size: 16px;">
                                        <span>
                                            ลำดับ {{ flow.inbox }}
                                        </span>
                                        <span v-if="flow.status.toLowerCase() === 'c' || transactionDetail.document_status.toLowerCase() === 'c'" style="color: #BDBDBD">
                                            ยกเลิกเอกสาร
                                        </span>
                                    </v-row>
                                    <v-row v-show="flow.actor.length" class="standard-row font-theme d-flex justify-space-between" :class="{ 'pb-2':  indexFlowName === flow.actor.length - 1}" v-for="(flowName, indexFlowName) in flow.actor" :key="`name${flowName}${indexFlowName}`" style="font-size: 16px;">
                                        <v-tooltip top :disabled="windowSize.x < 1400 || !trigCutName">
                                            <template v-slot:activator="{ on, attrs }">
                                                <span style="color: #A1A0A0;" v-on="on" v-bind="attrs">
                                                    {{ cutNameForLongName(flowName.emp_name.first_name_th, flowName.emp_name.last_name_th) }}
                                                </span>
                                            </template>
                                            <span class="font-theme">{{ flowName.emp_name.first_name_th }} {{ flowName.emp_name.last_name_th }}</span>
                                        </v-tooltip>
                                        <template v-if="['y', 'r','w'].includes(transactionDetail.document_status.toLowerCase()) && (flowName.account_id === flow.approver?.account_id || false)">
                                            <span v-if="flow.status.toLowerCase() === 'r'" style="color: #E08D8D">ปฏิเสธ</span>
                                            <span v-else-if="flow.status.toLowerCase() === 'y'" style="color: #1BDE3A">อนุมัติ</span>
                                        </template>
                                    </v-row>
                                    <v-row v-show="!flow.actor.length" class="standard-row font-theme pb-2" style="font-size: 16px; color: #A1A0A0;">
                                        ไม่พบรายชื่อในลำดับนี้
                                    </v-row>
                                    <v-row class="standard-row font-theme" style="font-size: 16px; color: #A1A0A0;" :class="{ 'mb-10':  flow.status.toLowerCase() !== 'w' || !flow.actor.find(e => e.account_id === raDetail.account_id) }">
                                        <v-textarea hide-details outlined background-color="white" :disabled="!(flow.status.toLowerCase() === 'w' && flow.actor.some(e => e.account_id === raDetail.account_id) && !resendStatus)" v-model="flow.comment" rows="4" color="black" class="comment-box-detail">
                                            <template v-slot:prepend-inner v-if="!flow.comment">
                                                <v-icon color="black">mdi-chat-processing-outline</v-icon>
                                            </template>
                                        </v-textarea>
                                    </v-row>
                                    <v-row class="standard-row d-flex justify-end mt-2 mb-10" v-if="flow.status.toLowerCase() === 'w' && flow.actor.find(e => e.account_id === raDetail.account_id) && !resendStatus">
                                        <v-btn height="21px" color="#4FE2CA" @click="updateTransaction(flow, 'Y')" style="border-radius: 4px; font-size: 14px; font-weight: 400; letter-spacing: 1px; box-shadow: none;" class="font-theme">
                                            อนุมัติ
                                        </v-btn>
                                        <v-btn height="21px" color="#F48484" @click="updateTransaction(flow, 'R')" style="border-radius: 4px; font-size: 14px; font-weight: 400; letter-spacing: 1px; box-shadow: none;" class="ml-2 font-theme">
                                            ปฎิเสธ
                                        </v-btn>
                                    </v-row>
                                </v-timeline-item>
                            </v-timeline>
                        </v-row>
                        <v-row v-if="transactionDetail.buyer.account_id === raDetail.account_id && !resendStatus" class="standard-row d-flex" style="padding: 0px 29px 29px 29px;" :class="transactionDetail.document_status.toLowerCase() === 'r'? 'justify-space-between': 'justify-end'">
                            <v-btn v-if="transactionDetail.document_status.toLowerCase() === 'r' || (transactionDetail.document_status.toLowerCase() === 'y' && ['r','c'].includes(document_status_dwf.toLowerCase()))" height="31px" color="#0B68D6" @click="editAndResendFn()" style="border-radius: 4px; font-size: 16px; font-weight: 700; letter-spacing: 1px; box-shadow: none;" class="ml-2 font-theme white--text">
                                แก้ไขและส่งใหม่
                            </v-btn>
                            <v-btn v-if="['w', 'r'].includes(transactionDetail.document_status.toLowerCase()) || (transactionDetail.document_status.toLowerCase() === 'y' && ['r','c'].includes(document_status_dwf.toLowerCase()))" height="31px" color="#D9D9D9"  @click="updateTransaction(null, 'C')" style="border-radius: 4px; font-size: 16px; font-weight: 700; letter-spacing: 1px; box-shadow: none;" class="ml-2 font-theme">
                                ยกเลิก
                            </v-btn>
                        </v-row>
                    </v-card>
                    <!-- mandala save budget -->
                    <v-card v-if="((['cost', 'rd', 'sga'].includes(inboxPermission?.toLowerCase())) || (['บัญชี'].includes(inboxPermission?.toLowerCase()) && (this.$group_biz_tax_id.includes(this.selectedBiz.tax_id)) && (selectedBiz.tax_id =='0105548134654'? transactionDetail?.products?.some(e => e.cut_budget_type !== 'ต้นทุนวิจัยและพัฒนา (R&D)'):transactionDetail?.products?.map(e => e.cut_budget_type)))) && !transactionDetail.skip_save_budget" class="standard-row external-card-detail-1 mt-5">
                    <!-- <v-card v-if="['cost', 'rd', 'sga'].includes(inboxPermission?.toLowerCase())" class="standard-row external-card-detail-1 mt-5"> -->
                        <v-row no-gutters class="standard-row font-theme py-5 px-5" align="center">
                            <v-col cols="auto" sm="auto" md="auto" lg="auto" style="font-size: 20px; font-weight: 400;">
                                บันทึกงบประมาณ
                            </v-col>
                            <v-spacer></v-spacer>
                            <div v-if="selectedBiz.tax_id === '0107544000094'">
                                <v-col cols="auto" sm="auto" md="auto" lg="auto" v-if="transactionDetail.save_budget.length && (transactionDetail.save_budget.some(item => item.type_budget.toLowerCase() === inboxPermission?.toLowerCase()) || groupBizJv)">
                                <img src="../assets/icon_success.png" style="margin-right: 1rem; margin-bottom: -5px">
                             </v-col>
                            </div>
                            <div v-else>
                            <v-col cols="auto" sm="auto" md="auto" lg="auto" v-if="transactionDetail.save_budget.length === this.unitItems.length">
                                <img src="../assets/icon_success.png" style="margin-right: 1rem; margin-bottom: -5px">
                            </v-col>
                            </div>
                            <v-col cols="auto" sm="auto" md="auto" lg="auto">
                                <v-btn height="31px" color="#0B68D6" @click="saveBudgetModal()" style="border-radius: 6px; font-size: 14px; font-weight: 500; letter-spacing: 1px; box-shadow: none;" class="font-theme white--text">
                                    บันทึก
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card>
                </div>
            </v-col>
        </v-row>
    </v-row>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import saveBudgetModal from '../components/saveBudgetModal.vue'
import UploadAttachFile from '../components/UploadAttachFile.vue'
import ConfirmCreatePurchaseModal from '../components/ConfirmCreatePurchaseModal.vue'
import ProductsCard from "../components/module/ProductsCard.vue";
    export default {
        components: {
            ConfirmCreatePurchaseModal,
            UploadAttachFile,
            saveBudgetModal,
            ProductsCard
        },
        data: () => ({
            //--------------- Data in Dropdown-----------------------------------------------------------------//
            goodsList: [],
            purchaseDataMeMo:'',
            vendorList: [],
            documentType: [],
            departmentList: [],
            costCenterList: [],
            unitList: [],
            searchOwnerList: [],
            Unit: ["Unit", "Month", "Project"],
            UnitSpecial: ["Unit", "Month", "Project", "Year"],
            UnitINET: ["Unit", "Month", "Project","License"],
            paymentCondition: ['Onetime', 'Recurring'],
            demandGoodsDropdownBizInet: ['สั่งซื้อสินค้าปกติ', 'เร่งด่วน','เร่งด่วนพิเศษ'],
            demandGoodsDropdown: ['สั่งซื้อสินค้าปกติ', 'เร่งด่วน'],
            licenseDropdown: ['Acronis','cPanel','Direcadmin','DUO','EPP/EDR Licenses','Fortigate','OPNsense','Other License','Palo','Plesk','RDS Easy D','Sophos','SPLA','SUSE','VCPP','Veeam'],
            budgetGroupDropdown: ['งบลงทุน', 'งบรายจ่ายประจำ', 'งบดำเนินงาน'],
            PurGroupName: ["BD Support", "Job Support", "GA Support"],
            prID: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11"],
            cutBudgetType: [],
            currencyCoinDropdown: ['ดอลลาร์ออสเตรเลีย', 'ยูโร European euro', 'ดอลลาร์สิงคโปร์', 'ดอลลาร์สหรัฐ', 'บาท'],
            //-------------------------------------------------------------------------------------------------//
            productData: [{ model: 0 }],
            permissionShowRowSignNo2: false,
            statusDisplay:false,
            textRules: [ v => !!v ],
            maxChars: [v => !!v && v.length <= 500],
            maxChars200: [v => !!v && v.length <= 200 || "เกินจำนวนตัวอักษรที่กำหนด (200 ตัวอักษร)"],
            windowSize: { x: 0, y: 0 },
            statusSearchingOwner: '',
            transactionDetail: {},
            hasMemo: false,
            startDatePicker: '',
            startDateMenu: false,
            checkDocument: false,
            endDatePicker: '',
            endDateMenu: false,
            uidCounter: 2,
            callApiPending: 0,
            isSameAllCurrency: true,
            isReady: false,
            listAttachFile: [],
            checkEmail: [],
            purchaseData: {},
            resendStatus: false,
            buyerBoardShowRow: null,
            waitStatusSearchCitizen: [],
            trigCutName: false,        
            productList: {
                "item": {
                    "material_name": null,
                    "material_code": null,
                    "gl_account": null,
                    "_id": null
                },
                "cut_budget_type": null,
                id_list: 1,
                "amount": null,
                "unit_price": null,
                "unit_type" : null,
                "total_product_price" : null,
                "currency": 'บาท',
                "currency_exchange": null,
                "vendor" : {
                    "vendor_name_th": "",
                    "vendor_code": ""
                },
                "budget_type": null,
                "pur_group_name": null,
                "cost_center": {
                    "costcenter_code": null,
                    "coscenter_description": null
                },
                "product_detail": null,
                "discount": null,
                "model": 0
            },
            purchaseMockData: {
                "employee_id": null,
                "section": null,
                "department" : null,
                "tax_id": null,
                "company" : null,
                "owner": {
                    "account_id": null,
                    "first_name_th": null,
                    "last_name_th": null,
                    "first_name_eng": null,
                    "last_name_eng": null,
                    "full_name_th": null,
                    "thai_email": null
                },
                "document_type": {
                    "name": null,
                    "pr_id": null,
                    "_id": null
                },
                "document_year": null,
                "has_memo" : null,
                "cs_memo" : null,
                "memo_no": null,
                "in_budget": null,
                "memo_budget": null,
                "remaining_budget": null,
                "qt_number": null,
                "project": null,
                "requirement" : null,
                "start_date": null,
                "end_date": null,
                "department_to_buy": null,
                "description": null,
                "total_price": null,
                "products": [],
                "buyer_board": {
                    "head_to_buy": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    },
                    "supply_board1": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    },
                    "supply_board2": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    },
                    "check_board1": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    },
                    "check_board2": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    },
                    "sign_no4": {
                        "account_id": null,
                        "first_name_th": null,
                        "last_name_th": null,
                        "first_name_eng": null,
                        "last_name_eng": null,
                        "full_name_th": null,
                        "thai_email": null,
                    }
                }
            },
            showRowSignNo4: false,
            showRowSignNo2:false,
            MaterialId: null,
            typingTimeout: null,
            getMemoNumber: {},
            document_status_dwf: '',
            thisYear: new Intl.DateTimeFormat('en-EN', {
                            year     : 'numeric',
                            timeZone : 'Asia/Bangkok'
                        }).format(new Date()),
            subCurrency: 'THB',
            noneCalCurrencyExchange: false,
            isSameCurrencyMemo: true,
            isInitialLoad: true,
        }),
        created() {
            window.addEventListener('beforeunload', this.handler)
        },
        mounted () {
            this.onResize()
            this.groupBizJv = this.$group_biz_tax_id.includes(this.selectedBiz.tax_id)
            this.purchaseData = this.purchaseMockData
            this.getShowRowSignNo2()
            if (this.transactionId) {
                if(this.permissionShowRowSignNo2 === false && !this.isCopyDocument){
                  this.statusDisplay = true  
                }             
                this.getDetailTransaction()
                this.getDocumentStatusDWF()
                if (!this.isCopyDocument) {
                    this.getListFiles()
                }
            } else {
                this.autoFillAndGetDropdown()
            }
            EventBus.$on('sendAttachmentFileToCreate', this.getAttachFileFromModal)
            EventBus.$on('backToPageGetDetailMemo', () => this.getMemoDetail(this.purchaseData.memo_no))
            EventBus.$on('afterSaveBudget', (save_budget_id) => save_budget_id? this.transactionDetail.save_budget.push({ "_id" : save_budget_id, "type_budget" : this.inboxPermission }) : null)
            EventBus.$on('afterSaveBudget', () => this.getDetailTransaction())
        },
        beforeDestroy () {
            this.$store.commit('setIsCopyDoc', false)
            this.$store.commit('setTransactionId', null)
            this.$store.commit('setSelectedPermissionInbox', null)
            EventBus.$off('afterSaveBudget')
            EventBus.$off('backToPageGetDetailMemo')
            EventBus.$off('sendAttachmentFileToCreate')
        },
        watch: {
            "callApiPending"(val) {
                if (val > 0) {
                    EventBus.$emit('loadingState', true)
                } else {
                    EventBus.$emit('loadingState', false)
                }
            },
            '$route.path'() {
                this.$nextTick(() => {
                    this.isReady = false
                    this.$store.commit('setIsCopyDoc', false)
                    this.$store.commit('setTransactionId', null)
                    location.reload();
                })
            },
            'purchaseData.license'(newVal, oldVal) {
                if (this.isInitialLoad) {
                    this.isInitialLoad = false
                    return
                }
                this.purchaseData.serial_number = ''
                if (
                    (['Fortigate','Palo'].includes(newVal) && ['Fortigate','Palo'].includes(oldVal) && newVal !== oldVal) ||
                    !['Fortigate','Palo'].includes(newVal)
                    ) {
                    this.purchaseData.renew = false
                }
            },
            cutBudgetType(newVal, oldVal) {
                if (newVal !== oldVal) {
                 this.getShowRowSignNo4()
                }
            },
            MaterialId(newVal, oldVal) {
                if (newVal !== oldVal) {
                 this.getShowRowSignNo4()
                }
            }
        },
        computed: {
            startDateShow() {
                return MainFunction.shortDate(this.purchaseData.start_date)
            },
            endDateShow() {
                return MainFunction.shortDate(this.purchaseData.end_date)
            },
            startDateDetailShow() {
                return MainFunction.shortDate(this.transactionDetail.start_date )
            },
            endDateDetailShow() {
                return MainFunction.shortDate(this.transactionDetail.end_date)
            },
            selectedBiz() {
                return this.$store.state.confirmSelectedBiz
            },
            raDetail() {
                return this.$store.state.raDetail
            },
            inboxPermission() {
                return this.$store.state.selectedPermissionInbox
            },
            transactionId() {
                return this.$store.state.transactionId
            },
            isCopyDocument() {
                return this.$store.state.isCopyDoc
            },
            setGetBudgetType () {
                return this.$store.state.budgetType
            },
            GroupAccountIdCreatePurchase(){
                return this.$store.state.groupAccountIdCreatePurchase
            },
            customHeight(){
                if (this.windowSize.x >= 1443) {
                    return '36.5px'
                } else if (this.windowSize.x >= 1264) {
                    return '23px'
                } else if(this.windowSize.x >= 960 && this.windowSize.x < 1264) {
                    return '42px'
                } else {
                    return 'unset'
                }
            },
            customHeightSerialNum() {
                return this.windowSize.x >= 1264 ? '80px' : 'auto'
            },
            customMarginSerialNum() {
                const renew = this.transactionDetail?.renew || this.purchaseData.renew
                return renew ? 'mt-lg-4' : ''
            },
            customAlignSerialNum() {
                const license = this.transactionDetail?.license || this.purchaseData.license
                return license === 'Sophos' ? 'align-content-lg-end' : ''
            },
            showTextfieldSerialNum() {
                return (
                    (this.purchaseData.has_license === true || this.transactionDetail.has_license === true) &&
                    (
                        ((this.purchaseData.renew === true && ['Fortigate', 'Palo'].includes(this.purchaseData.license)) || this.purchaseData.license === 'Sophos')
                        || ((this.transactionDetail.renew === true && ['Fortigate', 'Palo'].includes(this.transactionDetail.license)) || this.transactionDetail.license === 'Sophos')
                    )
                )
            }
        },          
        methods: {
            handleMaterialId(data) {
                this.$refs.boarderForm?.resetValidation();
                this.MaterialId = data.material_code;
                this.cutBudgetType = data.cut_budget_type;
                const normalCase = this.buyerBoardShowRow;
                const specialCase = this.showRowSignNo4;
                if ((specialCase === false) && this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094') {
                    this.$nextTick(() => {
                        this.$refs.boarderForm.reset();
                    });
                }
                if ((normalCase === false) && this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094') {
                    this.$nextTick(() => {
                        this.$refs.boarderForm.reset();
                    });
                }
                this.$nextTick(() => {                               
                     this.getShowRowSignNo4()     
                })         
            },           
            handler(){
                this.transactionDetail = {}
                this.$store.commit('setIsCopyDoc'    , null)
                this.$store.commit('setTransactionId', null)
            },
            getShowRowSignNo4() {
                const products = Array.isArray(this.purchaseData.products) && this.purchaseData.products.length > 0 ? this.purchaseData.products : this.transactionDetail.products || [];
                if ((this.purchaseData.requirement === 'เร่งด่วนพิเศษ'|| this.transactionDetail.requirement === 'เร่งด่วนพิเศษ' ) && (this.permissionShowRowSignNo2 === true || this.statusDisplay === true)){
                    this.buyerBoardShowRow = false;
                    this.showRowSignNo4 = false;
                    this.showRowSignNo2 = true
                }else if (this.selectedBiz.tax_id === '0107565000531'){
                        if (this.isCopyDocument) {
                            this.showRowSignNo4 = true
                            this.buyerBoardShowRow = false
                            return
                        }
                        const buyerBoard = this.transactionDetail?.buyer_board || {}
                        const boardLength = Object.keys(buyerBoard).length
                        if (boardLength <= 1) {
                            this.showRowSignNo4 = true
                            this.buyerBoardShowRow = false
                        } else {
                            this.buyerBoardShowRow = true
                            this.showRowSignNo4 = false
                        }
                }else{ 
                    if (this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094' && Array.isArray(products) && products.every(product =>(product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' 
                    && (product.item?.material_code || '').trim() === '22-62-0001')) {
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else if (
                    this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094' &&
                    Array.isArray(products) && products.every(product =>(product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && (product.item_id || '').toString().trim() === '22-62-0001')){
                        const buyerBoard = this.transactionDetail?.buyer_board || {} 
                        const boardLength = Object.keys(buyerBoard).length
                        if (boardLength <= 1) {
                        this.showRowSignNo4 = true
                        this.buyerBoardShowRow = false
                        } else {
                            if (this.isCopyDocument) {
                            this.showRowSignNo4 = true
                            this.buyerBoardShowRow = false
                            return
                            }
                        this.buyerBoardShowRow = true
                        this.showRowSignNo4 = false
                        this.showRowSignNo2 = false
                        }
                    }else if (
                    this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094' &&Array.isArray(products) && products.some(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && (product.item_id  || '').trim() === '22-62-0001')
                    &&products.every(product =>(product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)') && this.isCopyDocument){
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else if ( this.GroupAccountIdCreatePurchase &&this.selectedBiz.tax_id === '0107544000094' && Array.isArray(products) && products.every(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)')
                    && products.some(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && (product.item?.material_code || '').trim() === '22-62-0001')) {
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else if ( this.GroupAccountIdCreatePurchase &&this.selectedBiz.tax_id === '0107544000094' && Array.isArray(products) && products.every(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)')
                    && products.some(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' &&(product.item_id  || '').trim() === '22-62-0001') && !this.transactionDetail.buyer_board?.head_to_buy) {
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else if (!this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094' && Array.isArray(products) &&
                    products.every(product =>(product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' &&(product.item_id || '').toString().trim() === '22-62-0001') 
                    && this.transactionId && !this.isCopyDocument && !this.transactionDetail.buyer_board?.head_to_buy) {
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else if (!this.GroupAccountIdCreatePurchase && this.selectedBiz.tax_id === '0107544000094' && Array.isArray(products) &&  !this.transactionDetail.buyer_board?.head_to_buy &&
                    products.every(product =>(product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)') && this.transactionId && !this.isCopyDocument && products.some(product => (product.cut_budget_type || '').trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' &&(product.item_id  || '').trim() === '22-62-0001')) {
                        this.buyerBoardShowRow = false;
                        this.showRowSignNo4 = true;
                        this.showRowSignNo2 = false;
                    }else{
                        this.buyerBoardShowRow = true;
                        this.showRowSignNo4 = false;
                        this.showRowSignNo2 = false;
                    }
             }
            },
            onResize() {
                this.windowSize = { x: window.innerWidth }
            },
            addListProduct() {
                this.productData.push({ model: 0 })
            },
            getAttachFileFromModal(files = []) {
                this.listAttachFile = files
            },
            async confirmCreate() {
                for (let i = 0; i < this.purchaseData.products.length; i++) {
                    this.purchaseData.products[i] =
                        this.$refs.ProductsCard[i].sendProductData();
                }

                this.$refs.headerForm.validate()
                this.$refs.boarderForm.validate()
                this.$refs.productForm.validate()
                this.waitStatusSearchCitizen = []
                if (!this.$refs.headerForm.validate() || !this.$refs.boarderForm.validate() || !this.$refs.productForm.validate()) {
                    return this.alert('กรอกข้อมูลให้ครบถ้วน', 'Warning', 'info') 
                }
                if (!this.isSameAllCurrency) {
                    return this.alert('เลือกได้แค่ 1 สกุลเงิน', 'Warning', 'info')
                }
                if (!this.listAttachFile.length) {
                    return this.alert('กรุณาอัปโหลดเอกสารแนบ', 'Warning', 'info')
                }
                if (this.purchaseData.has_memo && (Number(this.purchaseData.remaining_budget.replace(/,/g, '') || 0) < 0)) {
                    return this.alert('งบประมาณคงเหลือไม่เพียงพอ', 'Warning', 'info')
                }
                if (!this.isSameCurrencyMemo) {
                    return this.alert('สกุลเงินไม่ตรงกับ Memo', 'Warning', 'info')
                }
                let tempPromise = []
                if (typeof this.purchaseData.owner === 'string') {
                    const lastNameOwnerClassify = this.purchaseData.owner.replace(/\s+/g, " ").trim().split(" ")
                    if (lastNameOwnerClassify.length < 2) {
                        return this.alert('ไม่พบข้อมูล! owner', 'Fail', 'error')
                    } else {
                        tempPromise.push({ keys  : 'owner', value : this.purchaseData.owner.replace(/\s+/g, " ").trim() })
                    }
                }
                for (const property in this.purchaseData.buyer_board) {
                    if (typeof this.purchaseData.buyer_board[property] === 'string') {
                        const lastNameClassify = this.purchaseData.buyer_board[property].replace(/\s+/g, " ").trim().split(" ")
                        if (lastNameClassify.length < 2) {
                            let titleAlert = ''
                            switch(property) {
                                case 'head_to_buy':
                                    titleAlert = 'ไม่พบข้อมูล! หัวหน้ากลุ่มงานขอซื้อ'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                                case 'supply_board1':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการจัดหา 1'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                                case 'supply_board2':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการจัดหา 2'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                                case 'check_board1':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ 1'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                                case 'check_board2':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ 2'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                                case 'sign_no4':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ'
                                    this.waitStatusSearchCitizen.push(property)
                                    break;
                            }
                            if (this.waitStatusSearchCitizen.length === 1) {
                                this.alert(titleAlert, 'Fail', 'error')
                            }
                        } else {
                            tempPromise.push({ keys  : property, value : this.purchaseData.buyer_board[property].replace(/\s+/g, " ").trim() })
                        }
                    }
                }
                if (this.waitStatusSearchCitizen.length) {
                    return this.waitStatusSearchCitizen = []
                }
                if (tempPromise.length) {
                    this.waitStatusSearchCitizen = await this.searchNameCitizen(tempPromise)
                    if (this.waitStatusSearchCitizen.length) {
                        for (let i = 0; i < this.waitStatusSearchCitizen.length; i++) {
                            let titleAlert = ''
                            switch(this.waitStatusSearchCitizen[i]) {
                                case 'owner':
                                    titleAlert = 'ไม่พบข้อมูล! Owner'
                                    break;
                                case 'head_to_buy':
                                    titleAlert = 'ไม่พบข้อมูล! หัวหน้ากลุ่มงานขอซื้อ'
                                    break;
                                case 'supply_board1':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการจัดหา 1'
                                    break;
                                case 'supply_board2':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการจัดหา 2'
                                    break;
                                case 'check_board1':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ 1'
                                    break;
                                case 'check_board2':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ 2'
                                    break;
                                case 'sign_no4':
                                    titleAlert = 'ไม่พบข้อมูล! คณะกรรมการตรวจรับ'
                                    break;
                            }
                            return this.alert(titleAlert, 'Fail', 'error')
                        }
                    }
                }
                const body = {
                    "employee_id" : this.raDetail.employee_id,
                    "section"     : this.purchaseData.section,
                    "department"  : this.purchaseData.department,
                    "tax_id"      : this.purchaseData.tax_id,
                    "company"     : {
                        "company_code" : this.purchaseData.company.company_code,
                        "company_name" : this.purchaseData.company.company_name
                    },
                    "owner"              : this.purchaseData.owner,
                    "document_type_id"   : this.purchaseData.document_type._id,
                    "document_type_name" : this.purchaseData.document_type.name,
                    "document_year"      : this.purchaseData.document_year,
                    "special_procurement_type"   : this.purchaseData.special_procurement_type === false ? false : this.purchaseData.special_procurement_type,
                    "has_memo"           : this.purchaseData.has_memo,
                    "cs_memo"            : this.purchaseData.cs_memo,
                    "qt_number"          : this.purchaseData.qt_number,
                    "project"            : this.purchaseData.project,
                    "requirement"        : this.purchaseData.requirement,
                    "start_date"         : this.purchaseData.start_date,
                    "end_date"           : this.purchaseData.end_date,
                    "department_to_buy"  : this.purchaseData.department_to_buy,
                    "description"        : this.purchaseData.description,
                    "ref_po"             : this.purchaseData.ref_po,
                    "has_license"        : this.purchaseData.has_license       || null,
                    "license"            : this.purchaseData.license           || null,
                    "renew"              : this.purchaseData.renew             || false,
                    "serial_number"      : this.purchaseData.serial_number     || null,
                    "total_price" : Number(this.purchaseData.total_price?.replace(/,/g, '')).toString(),
                    "products"    : this.purchaseData.products.map(e => {
                        return {
                            "item_id"                : e.item.material_code,
                            "item_name"              : e.item.material_name,
                            "cut_budget_type"        : e.cut_budget_type,
                            "amount"                 : e.amount?.replace(/,/g, ''),
                            "unit_price"             : e.unit_price?.replace(/,/g, ''),
                            "unit_type"              : e.unit_type?.toLowerCase(),
                            "currency"               : e.currency,
                            "currency_exchange"      : e.currency == 'บาท'? null : e.currency_exchange?.replace(/,/g, ''),
                            "vender_code"            : this.purchaseData.products[0].vendor.vendor_code,
                            "vender_name"            : this.purchaseData.products[0].vendor.vendor_name_th,
                            "total_product_price"    : e.total_product_price?.replace(/,/g, ''),
                            "budget_type"            : e.budget_type,
                            "type_budget"            : e.item.gl_account ?? e.type_budget ?? null,
                            "pur_group_name"         : e.pur_group_name,
                            "cost_center_id"         : e.cost_center?.costcenter_code,
                            "product_detail"         : e.product_detail,
                            "cost_center_description": e.cost_center?.coscenter_description,
                            "discount"               : e.discount?.replace(/,/g, '')
                        }
                    }),
                    "memo": this.purchaseData.has_memo? {
                        "_id"              : this.purchaseData?.memo_id                               || null,
                        "memo_no"          : this.purchaseData?.memo_no                            || null,
                        "in_budget"        : typeof this.purchaseData.in_budget  === 'boolean'? this.purchaseData.in_budget :null,
                        "memo_budget"      : this.purchaseData?.memo_budget?.replace(/,/g, '')     || null,
                        "remaining_budget" : this.purchaseData?.remaining_budget?.replace(/,/g, '') || null,
                        "currency"         : this.purchaseData?.memo_currency                     || null,
                        "memo_department"  : this.purchaseData?.department                        || null,
                    } :null,
                    "buyer_board": (() => {
                        if((this.purchaseData.requirement === 'เร่งด่วนพิเศษ'|| this.transactionDetail.requirement === 'เร่งด่วนพิเศษ' )&& this.permissionShowRowSignNo2 === true){
                            return { 
                                "check_board1"  : this.purchaseData.buyer_board?.check_board1  || null,
                                "check_board2"  : this.purchaseData.buyer_board?.check_board2  || null
                            }
                        }else{
                            if (this.showRowSignNo4 && this.selectedBiz.tax_id === '0107544000094' && this.GroupAccountIdCreatePurchase ) {
                                return { 
                                    "supply_board1": this.purchaseData.buyer_board?.sign_no4 || null
                                    }
                            } else if (this.showRowSignNo4 && this.selectedBiz.tax_id === '0107565000531') {
                                    return { 
                                     "supply_board1"  : this.purchaseData.buyer_board?.sign_no4 || null
                                    }
                            } else {
                                return {
                                "head_to_buy"   : this.purchaseData.buyer_board?.head_to_buy   || null,
                                "supply_board1" : this.purchaseData.buyer_board?.supply_board1 || null,
                                "supply_board2" : this.purchaseData.buyer_board?.supply_board2 || null,
                                "check_board1"  : this.purchaseData.buyer_board?.check_board1  || null,
                                "check_board2"  : this.purchaseData.buyer_board?.check_board2  || null
                                }
                            }
                    }
                    })(),
                }
                EventBus.$emit('confirmCreatePurchaseRequisition', body, this.listAttachFile, (this.transactionId && this.resendStatus)? { "transaction_id": this.transactionId, "document_id": this.transactionDetail.document_id }: false)
            },
            uploadAttachFile() {
                let isShowUploadButton = true;
                let files = [];
                if (this.transactionId) {
                    const { flow_step, document_status } = this.transactionDetail;

                    const waitingOrder = flow_step.find((order) => order.status.toLowerCase() === "w") || [];
                    const isAllowByAccountId = waitingOrder.actor?.some(
                        ({ account_id }) => account_id === this.raDetail.account_id
                    );
                    if (
                        (document_status.toLowerCase() === "r" && this.resendStatus) ||
                        (Object.keys(waitingOrder)?.length &&
                        isAllowByAccountId &&
                        this.transactionDetail.buyer.account_id ===
                        this.raDetail.account_id &&
                        !this.resendStatus) ||
                        (this.transactionDetail.buyer.account_id === this.raDetail.account_id && !this.resendStatus)
                    ) {
                        isShowUploadButton = true;
                    } else {
                        isShowUploadButton = false;
                    }

                    if (this.listAttachFile.length) {
                        files = [...this.listAttachFile];
                    }
                } else {
                    isShowUploadButton = true;
                    files = [...this.listAttachFile] || [];
                }
                EventBus.$emit(
                    "uploadFileForPurchaseRequisition",
                    files,
                    isShowUploadButton,
                    this.transactionId,
                    this.transactionDetail || null
                );
            },
            async autoFillAndGetDropdown() {
                try {
                    this.callApiPending++
                    if (!this.transactionId) {
                        this.purchaseData.employee_id = {
                            name        : `${this.raDetail.first_name_th} ${this.raDetail.last_name_th}`,
                            employee_id : this.raDetail.employee_id
                        }
                        this.purchaseData.section           = this.raDetail.orgchart?.section?.length? this.raDetail.orgchart?.section?.[0]?.orgChartName  :this.raDetail.orgchart?.lineOfWork?.[0]?.orgChartName || null
                        this.purchaseData.department        = this.raDetail.orgchart?.department?.[0]?.orgChartName || null
                        this.purchaseData.department_to_buy = this.raDetail.orgchart?.department?.[0]?.orgChartName || null
                        this.purchaseData.tax_id            = this.selectedBiz.tax_id || null
                        this.purchaseData.company = {
                            company_code : this.selectedBiz.company_code || null,
                            company_name : this.selectedBiz.company_name || null
                        }
                        this.purchaseData.products.push({...this.productList})
                        this.purchaseData.document_year = this.thisYear
                        this.isReady = true
                    }
                    if (this.documentType.length && this.goodsList.length && this.vendorList.length && this.costCenterList.length) {
                        return
                    }
                    const getDocTypeList = {
                        baseURL : this.$api_url,
                        url     : `/document_type/api/v1/get_document_type?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }
                    const getGoodsList = {
                        baseURL : this.$api_url,
                        url     : `/item_erp/api/v1/show_itemerp?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }
                    const getVendorList = {
                        baseURL : this.$api_url,
                        url     : `/vendor_erp/api/v1/show_vendorerp?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }
                    const getCostCenterList = {
                        baseURL : this.$api_url,
                        url     : `/costcenter/api/v1/get_costcenter?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }
                    const getUnitList = {
                        baseURL : this.$api_url,
                        url     : `/unit_type/api/v1/get_unit_type?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }
                    const getListMemo = {
                        baseURL : this.$api_url,
                        url     : `/memo_budget/api/v1/list_memo?tax_id=${this.selectedBiz.tax_id}`,
                        method  : 'GET'
                    }

                    const data = await Promise.all([ this.axios(getDocTypeList), this.axios(getGoodsList), this.axios(getVendorList), this.axios(getCostCenterList), this.axios(getUnitList) ,this.axios(getListMemo) ])
                    this.documentType   = data[0].data?.data
                    this.goodsList = data[1].data?.data?.map(key => {
                        const { material_code, material_name, gl_account, _id } = key
                        return { material_code, material_name, gl_account, _id }
                    }) || []
                    this.vendorList = data[2].data?.data?.map(key => {
                        const { vendor_name_th, vendor_code, _id , keyword } = key
                        return { vendor_name_th, vendor_code, _id,keyword }
                    }) || []
                    this.costCenterList = data[3].data?.data?.map(key => {
                        const { costcenter_code, coscenter_description } = key
                        return { costcenter_code, coscenter_description }
                    }) || []
                    this.unitList = data[4].data?.data || []
                    if (this.resendStatus || this.isCopyDocument) {
                        this.autoFillFromEditor()
                    }
                    this.memoList = (data[5].data?.data.map(item => ({
                        _id : item._id,
                        in_budget: item.in_budget,
                        memo_no: item.memo_no,
                        memo_budget: item.memo_budget,
                        remaining_budget: item.remaining_budget,
                        currency: item?.currency || 'บาท'
                    }))) || [];

                } catch (error) {
                    console.log(error)
                    if (this.isCopyDocument) {
                        this.alert('คัดลอกเอกสารไม่สำเร็จ', 'Fail', 'error')
                    } else {
                        this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                    }
                    this.backToInbox()
                } finally {
                    this.callApiPending--
                }
            },
            async searchCitizen(name) {
                if (typeof name !== 'string' || !name) {
                    return
                }
                try {
                    this.searchOwnerList = []
                    this.statusSearchingOwner = "กำลังค้นหาข้อมูล..."
                    // const url = `/citizen/api/v1/searchRa2`
                    // const url = `/citizen/api/v1/search_ra`
                    const { data } = await this.axios.post(`${this.$api_url}/citizen/api/v1/searchRa2`, { keyword: name })
                    if (data.status && data.result.length) {
                        for (let j = 0; j < data.result.length; j++) {
                            this.searchOwnerList.push({
                                "account_id"         : data.result[j]?.id               || null,
                                "first_name_th"      : data.result[j]?.first_name_th    || null,
                                "last_name_th"       : data.result[j]?.last_name_th     || null,
                                "first_name_eng"     : data.result[j]?.first_name_eng   || null,
                                "last_name_eng"      : data.result[j]?.last_name_eng    || null,
                                "thai_email"         : data.result[j]?.thai_email       || null,
                                "full_name_th"       : `${data.result[j]?.first_name_th || null} ${data.result[j]?.last_name_th || null}`,
                            })
                        }
                    } else {
                        this.searchOwnerList = []
                        this.statusSearchingOwner = "ไม่พบข้อมูล"
                    }
                } catch (error) {
                    console.log(error)
                    this.searchOwnerList = []
                    this.statusSearchingOwner = "ไม่พบข้อมูล"
                }
            },
            addMoreProducts() {
                if (this.purchaseData.products.length < 60) {
                    const { vendor, budget_type } = this.purchaseData.products[0];
                    const productTemp = {
                        ...this.productList,
                        vendor,
                        budget_type,
                        id_list: this.uidCounter++
                    };
                    if (
                    this.selectedBiz.tax_id === '0107544000094' &&
                    this.purchaseData.requirement === 'เร่งด่วนพิเศษ'
                    ) {
                        productTemp.budget_type = 'งบดำเนินงาน'
                        productTemp.cut_budget_type = 'ต้นทุนขาย (COGS)'
                        productTemp.pur_group_name = 'Job Support'
                        productTemp.disabledSelect = true
                    } 
                    this.purchaseData.products.push(productTemp);
                    // this.calculateCost(productTemp);
                } else {
                    this.alert("รายการสินค้าสูงสุดแล้ว", "Warning", "info");
                }
            },
            calculateCost() {
                const { products, has_memo, memo_budget } = this.purchaseData;

                let totalPrice = 0;
                let realTotalPrice = 0;
            if(this.selectedBiz.tax_id === '0107544000094') {
                switch (products[0].currency) {
                    case 'ดอลลาร์ออสเตรเลีย':
                        this.subCurrency = 'AUD'
                        break;
                    case 'ยูโร European euro':
                        this.subCurrency = 'EUR'
                        break;
                    case 'ดอลลาร์สิงคโปร์':
                        this.subCurrency = 'SGD'
                        break;
                    case 'หยวน':
                        this.subCurrency = 'CNY'
                        break;
                    case 'ดอลลาร์สหรัฐ':
                        this.subCurrency = 'USD'
                        break;
                }
            }else{
                switch (products[0].currency) {
                    case 'ดอลลาร์ออสเตรเลีย':
                        this.subCurrency = 'AUD'
                        break;
                    case 'ยูโร European euro':
                        this.subCurrency = 'EUR'
                        break;
                    case 'ดอลลาร์สิงคโปร์':
                        this.subCurrency = 'SGD'
                        break;
                    case 'ดอลลาร์สหรัฐ':
                        this.subCurrency = 'USD'
                        break;
                }
            }
                this.isSameAllCurrency = products.reduce((acc, current) => {
                    let { currency, total_product_price, discount, currency_exchange } =
                    current;
                    
                    if (!acc || (currency !== products[0].currency)) {
                        return false
                    }
                const otherCurrencyMemo = this.purchaseData?.memo_currency && this.purchaseData?.memo_currency !== 'บาท'
                    total_product_price = this.replaceCommaToNumber(total_product_price);
                    totalPrice += total_product_price;
                    discount = this.replaceCommaToNumber(discount);
                    currency_exchange = this.replaceCommaToNumber(currency_exchange);
                    if(otherCurrencyMemo) {
                        realTotalPrice += (total_product_price - discount)
                        if (this.subCurrency !== this.purchaseData.memo_currency) this.isSameCurrencyMemo = false
                        else this.isSameCurrencyMemo = true
                    } else {
                        realTotalPrice +=
                        (total_product_price - discount) * (currency_exchange || 1);
                    }
                    return true;
                }, true);

                if (this.isSameAllCurrency) {
                    this.$set(
                        this.purchaseData,
                        "total_price",
                        this.addComma(totalPrice.toFixed(2))
                    );
                    if (has_memo && memo_budget) {
                        const memoBudget = this.replaceCommaToNumber(memo_budget);
                        this.purchaseData.remaining_budget = MainFunction.addComma(parseFloat(memoBudget - realTotalPrice).toFixed(2));
                    }
                } else {
                    this.purchaseData.total_price = null;
                    this.purchaseData.remaining_budget = null;
                }
            },
            replaceCommaToNumber(value) {
                return Number(value?.replace(/,/g, "") || "0");
            },
            addComma(value) {
                return MainFunction.addComma(Number(value || "0"));
            },
            async searchNameCitizen(params) {
                if (!params?.length) {
                    return
                }
                try {
                    let tempPromise = []
                    this.callApiPending++
                    for (let i = 0; i < params.length; i++) {
                        tempPromise.push({
                            method  : 'POST',
                            baseURL : this.$api_url,
                            url     : `/citizen/api/v1/searchRa2`,
                            // url     : `/citizen/api/v1/search_ra`,
                            data    : { keyword: params[i].value || '' }
                        })
                    }
                    const data = await Promise.all(tempPromise.map(e => this.axios(e)))
                    let tempCheckData = []
                    for (let i = 0; i < data.length; i++) {
                        if (data[i].data.status && data[i].data.result.length === 1) {
                            const tempDataCitizen =  {
                                "account_id"     : data[i].data.result[0].id             || null,
                                "first_name_th"  : data[i].data.result[0].first_name_th  || null,
                                "last_name_th"   : data[i].data.result[0].last_name_th   || null,
                                "first_name_eng" : data[i].data.result[0].first_name_eng || null,
                                "last_name_eng"  : data[i].data.result[0].last_name_eng  || null,
                                "thai_email"     : data[i].data.result[0].thai_email     || null,
                                "full_name_th"   : `${data[i].data.result[0].first_name_th || null} ${data[i].data.result[0].last_name_th || null}`
                            }
                            if (params[i].keys === 'owner') {
                                this.purchaseData.owner = tempDataCitizen
                            } else {
                                this.purchaseData.buyer_board[params[i].keys] = tempDataCitizen
                            }
                        } else {
                            tempCheckData.push(params[i].keys)
                        }
                    }
                    if (tempCheckData.length) {
                        return tempCheckData
                    } else {
                        return true
                    }
                } catch (error) {
                    console.log(error);
                    return false
                } finally {
                    this.callApiPending--
                }
            },

            iconStatus(){
                let convertedTypeBudget;
                const originalTypeBudget = this.transactionDetail?.products?.map(e => e.cut_budget_type);
                    if (originalTypeBudget.cut_budget_type === 'ต้นทุนขาย (COGS)') {
                        convertedTypeBudget = 'COST';
                    } else if (originalTypeBudget.cut_budget_type === 'ต้นทุนวิจัยและพัฒนา (R&D)') {
                        convertedTypeBudget = 'RD';
                    } else {
                        convertedTypeBudget = 'SGA';
                    } 
                    this.unitItems = [...new Set(originalTypeBudget)];
                    let iConSuccess = this.transactionDetail.save_budget.map(e=> e.type_budget == originalTypeBudget)
                    this.iconSuccess = iConSuccess.length === this.unitItems.length
            },
            
            //-----------------------------------------------------------------------------------------------
            async getDetailTransaction() {
                try {
                    this.callApiPending++
                    const { data } = await this.axios.get(`${this.$api_url}/transaction/api/v1/transaction_detail?transaction_id=${this.transactionId || ''}`)
                    if (data.status && Object.keys(data.data).length) {
                        this.transactionDetail = data.data
                        this.transactionDetail.products.forEach(e => {
                            e.model               = 0
                            e.amount              = MainFunction.addComma(Number(e.amount)     || '0')
                            e.unit_price          = MainFunction.addComma(Number(e.unit_price) || '0')
                            e.product_detail      = e.product_detail || null
                            e.total_product_price = MainFunction.addComma(Number(e.total_product_price) || '0'),
                            e.discount            = MainFunction.addComma(Number(e.discount)   || '0')
                            e.cut_budget_type     = this.setGetBudgetType.map(type => type.type_name).includes(e.cut_budget_type) ? e.cut_budget_type : null
                        })
                        this.transactionDetail.memo_id            = data.data.has_memo? data.data.memo._id     || null :null
                        this.transactionDetail.memo_no            = data.data.has_memo? data.data.memo.memo_no || null :null
                        this.transactionDetail.in_budget          = data.data.has_memo? (typeof data.data.memo.in_budget === 'boolean'? data.data.memo.in_budget : null) :null
                        this.transactionDetail.memo_budget        = data.data.has_memo? (MainFunction.addComma(Number(data.data.memo.memo_budget) || '0')  || null)      :null
                        this.transactionDetail.remaining_budget   = data.data.has_memo? (MainFunction.addComma(Number(data.data.memo.remaining_budget) || '0')  || null) :null
                        this.transactionDetail.memo_currency      = data.data.has_memo? data.data.memo?.currency || null : null
                        this.transactionDetail.save_budget        = data.data.save_budget || null 
                        this.transactionDetail.total_price        = MainFunction.addComma(Number(this.transactionDetail.total_price) || '0')
                        this.transactionDetail.pr_id              = this.transactionDetail.document_type_name?.split(' ')[0]
                        this.transactionDetail.buyer.full_name_th = `${data.data.buyer?.first_name_th || ''} ${data.data.buyer?.last_name_th || ''}`
                        if (this.isCopyDocument) {
                            if (data.data.has_memo && data.data?.memo?._id && data.data?.memo?.memo_no) {
                                this.getMemoDetail(data.data.memo.memo_no)
                            }
                            this.autoFillAndGetDropdown()
                        }
                        this.iconStatus()
                        this.getShowRowSignNo4()
                        if (this.selectedBiz.tax_id === '0107544000094' &&this.GroupAccountIdCreatePurchase &&Array.isArray(this.transactionDetail.products) 
                        && this.transactionDetail.products.some(e => e.item_id === '22-62-0001' && e.cut_budget_type === 'ค่าใช้จ่ายขายและบริการ (SG&A)')) {
                            const firstProduct = this.transactionDetail.products.find(e => e.item_id === '22-62-0001');
                            if (firstProduct) {
                                this.MaterialId = '22-62-0001';
                                this.cutBudgetType = firstProduct.cut_budget_type;
                            }
                        }
                    }
                } catch (error) {
                    console.log(error)
                    if (this.isCopyDocument) {
                        this.alert('คัดลอกเอกสารไม่สำเร็จ', 'Fail', 'error')
                    } else {
                        this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                    }
                    this.backToInbox()
                } finally {
                    this.callApiPending--
                    if (!this.isCopyDocument) {
                        this.isReady = true
                    }
                }
            },
            async updateTransaction(flowStep, action) {
                if (!action) {
                    return
                }
                if (this.selectedBiz.tax_id === '0107544000094' && flowStep && flowStep?.inbox !== 'บัญชี' && flowStep?.inbox !== 'จัดซื้อ' && !this.transactionDetail.skip_save_budget) {
                    if (action?.toLowerCase() === 'y' && ((flowStep.inbox?.toLowerCase() === this.inboxPermission?.toLowerCase() && !this.transactionDetail.save_budget?.find(e => e.type_budget?.toLowerCase() === this.inboxPermission?.toLowerCase())?._id) || (flowStep.inbox?.toLowerCase() !== this.inboxPermission?.toLowerCase() && !this.transactionDetail.save_budget?.find(e => e.type_budget?.toLowerCase() === flowStep.inbox?.toLowerCase())?._id))) {
                        return this.alert('บันทึกงบประมาณก่อนทำรายการ', 'Warning', 'info')
                    }
                //mandala savebudget
                } else if (this.groupBizJv && flowStep && flowStep?.inbox === 'บัญชี' && !this.transactionDetail.skip_save_budget) {
                    let numberTypeBudget = [...new Set(this.transactionDetail.products.map(e => e.cut_budget_type))].length
                    if (action?.toLowerCase() === 'y' && (!this.transactionDetail.save_budget.length || this.transactionDetail.save_budget?.length !== numberTypeBudget)) {
                        return this.alert('บันทึกงบประมาณก่อนทำรายการ', 'Warning', 'info')
                    }
                }
                try {
                    this.callApiPending++
                    if (action === 'C') {
                        var body = { "status"  : 'C' }
                    } else {
                        var body = {
                            "index"   : flowStep.index,
                            "comment" : flowStep.comment || null,
                            "status"  : action
                        }
                    }
                    const { data } = await this.axios.put(`${this.$api_url}/transaction/api/v1/update_transaction/${this.transactionId || ''}`, body)
                    if (data.status) {
                        let titleText = ''
                        if (action === 'Y') {
                            titleText = 'อนุมัติเอกสารสำเร็จ'
                        } else if (action === 'C') {
                            titleText = 'ยกเลิกเอกสารสำเร็จ'
                        } else {
                            titleText = 'ปฏิเสธเอกสารสำเร็จ'
                        }
                        this.alert(titleText, 'Success', 'success')
                        if (this.listAttachFile.length) {
                            const tempAttachFile = this.listAttachFile?.filter(e => !e.file_id)
                            if (tempAttachFile.length) {
                                return this.uploadAttachFileToAPI(this.transactionId, tempAttachFile)
                            }
                        }
                        this.getDetailTransaction()
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('เกิดข้อผิดพลาด', 'Fail', 'error')
                } finally {
                    this.callApiPending--
                }
            },
            async uploadAttachFileToAPI(transactionId = '', files = []) {
                if (!transactionId || !files.length) {
                    this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                    return
                }
                try {
                    this.callApiPending++
                    let formData = new FormData()
                    formData.append('transaction_id', transactionId)
                    for (let i = 0; i < files.length; i++) {
                        formData.append('file', files[i])
                    }
                    const { data } = await this.axios.post(`${this.$api_url}/attach_file/api/v1/save_file`, formData)
                    if(data.status) {
                        this.getListFiles()
                    } else {
                        this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                    }
                } catch (error) {
                    console.log(error)
                    this.alert('อับโหลดไฟล์แนบไม่สำเร็จ', 'Fail', 'error')
                } finally {
                    this.callApiPending--
                    this.getDetailTransaction()
                }
            },
            async getListFiles() {
                try {
                    this.listAttachFile = []
                    const { data } = await this.axios.get(`${this.$api_url}/attach_file/api/v1/list_attachment_file?transaction_id=${this.transactionId || ''}`)
                    if (data.status && data.data.length) {
                        this.listAttachFile = data.data
                        for (let i = 0; i < this.listAttachFile.length; i++) {
                            this.listAttachFile[i].name = this.listAttachFile[i].file_name
                            delete this.listAttachFile[i].file_name
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            autoFillFromEditor() {
                this.purchaseData = {
                    "employee_id"                 : {
                        "name"        : `${this.raDetail.first_name_th} ${this.raDetail.last_name_th}`,
                        "employee_id" : this.raDetail.employee_id
                    },
                    "section"                     : this.raDetail.orgchart?.section?.length? this.raDetail.orgchart?.section?.[0]?.orgChartName  :this.raDetail.orgchart?.lineOfWork[0]?.orgChartName,
                    "department"                  : this.raDetail.orgchart?.department?.[0]?.orgChartName || null,
                    "tax_id"                      : this.selectedBiz.tax_id || null,
                    "company"                     : {
                        "company_code" : this.selectedBiz.company_code || null,
                        "company_name" : this.selectedBiz.company_name || null
                    },
                    "document_year"               : this.thisYear     || null,
                    "owner"                       : this.transactionDetail.owner             || null,
                    "document_type"               : this.documentType.find(e => e._id === this.transactionDetail.document_type_id) || null,
                    "special_procurement_type"    : this.transactionDetail.special_procurement_type === false ? false : this.transactionDetail.special_procurement_type,
                    "has_memo"                    : typeof this.transactionDetail.has_memo === 'boolean'? this.transactionDetail.has_memo :null,
                    "memo_id"                     : this.transactionDetail.has_memo? this.transactionDetail.memo._id || null :null,
                    "memo_no"                     : this.transactionDetail.has_memo? this.transactionDetail.memo.memo_no || null :null,
                    "in_budget"                   : this.transactionDetail.has_memo? (typeof this.transactionDetail?.memo?.in_budget === 'boolean'? this.transactionDetail.memo.in_budget : null) :null,
                    "memo_budget"                 : this.transactionDetail.has_memo? this.getMemoNumber.remaining_budget || null :null,
                    "remaining_budget"            : this.transactionDetail.has_memo? MainFunction.addComma(Number(this.transactionDetail.remaining_budget)) || null :null,
                    "memo_currency"               : this.transactionDetail.has_memo? this.getMemoNumber?.currency || 'บาท' : 'บาท',
                    "cs_memo"                     : this.transactionDetail.cs_memo           || null,
                    "qt_number"                   : !this.isCopyDocument? this.transactionDetail.qt_number : null,
                    "project"                     : this.transactionDetail.project || null,
                    "requirement"                 : this.transactionDetail.requirement       || null,
                    "start_date"                  : this.transactionDetail.start_date        || null,
                    "end_date"                    : this.transactionDetail.end_date          || null,
                    "department_to_buy"           : this.transactionDetail.department_to_buy || null,
                    "description"                 : this.transactionDetail.description       || null,
                    "ref_po"                      : this.purchaseData.ref_po                 || null,
                    "total_price"                 : this.transactionDetail.total_price       || null,
                    "license"                     : this.transactionDetail.license           || null,
                    "has_license"                 : this.transactionDetail.has_license       || null,
                    "renew"                       : this.transactionDetail.renew             || false,
                    "serial_number"               : this.transactionDetail.serial_number     || null,
                    "products"                    : this.transactionDetail?.products?.map(e => {
                        return {
                            "item"                : this.goodsList.find(
                                ({ material_code, material_name }) =>
                                    material_code === e.item_id && material_name === e.item_name
                            ),
                            "cut_budget_type"     : this.transactionDetail.requirement === 'เร่งด่วนพิเศษ' ? 'ต้นทุนขาย (COGS)': e?.cut_budget_type              || null,
                            "amount"              : e?.amount                       || null,
                            "unit_price"          : e?.unit_price                   || null,
                            "unit_type"           : e?.unit_type?.charAt(0).toUpperCase() + e.unit_type?.slice(1) || null,
                            "total_product_price" : e?.total_product_price          || null,
                            "currency"            : e?.currency                     || null,
                            "currency_exchange"   : e?.currency_exchange            || null,
                            "vendor"              : this.vendorList.find(
                                ({ vendor_name_th, vendor_code }) =>
                                    vendor_name_th === e.vender_name && vendor_code === e.vender_code
                            ),
                            "budget_type"         : e?.budget_type                  || null,
                            "type_budget"         : e?.type_budget                  || null,
                            "pur_group_name"      : e?.pur_group_name               || null,
                            "product_detail"      : e?.product_detail               || null,
                            "cost_center"         : {
                                "costcenter_code"       : e.cost_center_id          || null,
                                "coscenter_description" : e.cost_center_description || null
                            },
                            "discount"            : e?.discount                     || null,
                            "model"               : 0,
                            "requirement"         : this.permissionShowRowSignNo2 === true ? this.transactionDetail.requirement : null,
                        }
                    }) || [],
                   "buyer_board": (() => {
                        if((this.purchaseData.requirement === 'เร่งด่วนพิเศษ'|| this.transactionDetail.requirement === 'เร่งด่วนพิเศษ' )&& this.permissionShowRowSignNo2 === true){
                            return { 
                                "check_board1"  : this.transactionDetail.buyer_board?.check_board1  || null,
                                "check_board2"  : this.transactionDetail.buyer_board?.check_board2  || null
                            }
                        }else{
                            if (this.showRowSignNo4 && this.selectedBiz.tax_id === '0107544000094' && this.GroupAccountIdCreatePurchase ) {
                                return { 
                                    "sign_no4"  :this.transactionDetail.buyer_board?.supply_board1 || null
                                }
                            } else if (this.showRowSignNo4 && this.selectedBiz.tax_id === '0107565000531') {
                                return { 
                                    "sign_no4"  :this.transactionDetail.buyer_board?.supply_board1 || null
                                }
                            } else { 
                                return {
                                "head_to_buy"   : this.transactionDetail.buyer_board?.head_to_buy   || null,
                                "supply_board1" : this.transactionDetail.buyer_board?.supply_board1 || null,
                                "supply_board2" : this.transactionDetail.buyer_board?.supply_board2 || null,
                                "check_board1"  : this.transactionDetail.buyer_board?.check_board1  || null,
                                "check_board2"  : this.transactionDetail.buyer_board?.check_board2  || null
                                }
                            }
                    }
                    })(),
                }
                for (let i = 0; i < this.purchaseData.products.length; i++) {
                    this.calculateCost(this.purchaseData.products[i])
                }
                if (this.isCopyDocument) {
                    this.transactionDetail = {}
                    // this.$store.commit('setIsCopyDoc'    , null)
                    this.$store.commit('setTransactionId', null)
                } else {
                    this.transactionDetail.has_memo         = null
                    this.transactionDetail.memo_no          = null
                    this.transactionDetail.in_budget        = null
                    this.transactionDetail.memo_budget      = null
                    this.transactionDetail.remaining_budget = null
                }
                this.isReady = true
            },
            getAttachFileFromModal(files = []) {
                this.listAttachFile = files
            },
            showUploadFileButton() {
                if (this.transactionId) {
                    if (this.transactionDetail.document_status.toLowerCase() === 'w') {
                        if (this.transactionDetail.flow_step.find(e => e.status.toLowerCase() === 'w')?.actor.some(e => e.account_id === this.raDetail.account_id)) {
                            return true
                        } else {
                            if (this.listAttachFile.length) {
                                return true
                            }
                            return false
                        }
                    }else if(this.transactionDetail.document_status.toLowerCase() === 'y' && this.document_status_dwf.toLowerCase() === 'r'){
                        return true
                    } else {
                        if ((this.transactionDetail.document_status.toLowerCase() === 'r' && this.resendStatus) || this.listAttachFile.length) {
                            return true
                        }
                    }
                } else {
                    return true
                }
            },
            backToInbox() {
                this.$store.commit('setIsCopyDoc', false)
                this.$store.commit('setTransactionId', null)
                this.$router.push({ path: '/inbox'})
            },
            errorCheckName(key) {
                let errorCheck = false
                if (key && this.waitStatusSearchCitizen.length) {
                    errorCheck = this.waitStatusSearchCitizen.includes(key)
                }
                return errorCheck
            },
            paddingBackToInboxBtn() {
                let paddingTemp = ''
                if (this.transactionId && this.windowSize.x >= 1400) {
                    paddingTemp = '32px 1% 0% 2%;'
                } else if (this.transactionId && this.windowSize.x < 1400) {
                    paddingTemp = '32px 8% 0% 9%;'
                }
                if (this.isCopyDocument) {
                    paddingTemp = '32px 8% 0% 9%;'
                }
                return paddingTemp
            },
            disableTooltip(value) {
                if (!value) {
                    return true
                } else {
                    if (typeof value === 'string' && value) {
                        return false
                    } else if (typeof value === 'object' && value.full_name_th) {
                        return false
                    } else {
                        return true
                    }
                }
            },
            showNameCitizenTooltip(value) {
                if (!value) {
                    return 'ไม่มีข้อมูล'
                } else {
                    if (typeof value === 'string' && value.length) {
                        return value
                    } else if (typeof value === 'object' && value.full_name_th) {
                        return value.full_name_th || 'ไม่มีข้อมูล'
                    } else {
                        return 'ไม่มีข้อมูล'
                    }
                }
            },
            cutNameForLongName(firstName, lastName) {
                if ((firstName.length + lastName.length) <= 23 || this.windowSize.x < 1400) {
                    return `${firstName} ${lastName}`
                } else {
                    this.trigCutName = true
                    return `${firstName.substring(0, 9)}... ${lastName.substring(0, 9)}...`
                }
            },
            saveBudgetModal() {
                let tempTypeBudget = []
                //mandala save budget
                // let nonCut_budget_type = null;
                // const nonRDCutBudget = this.transactionDetail?.products?.filter(e => e.cut_budget_type !== 'ต้นทุนวิจัยและพัฒนา (R&D)');
                //     if (nonRDCutBudget) {
                //         nonCut_budget_type = nonRDCutBudget.map(e => e.cut_budget_type );
                //     }
                    this.transactionDetail?.products?.forEach(e => { 
                    //mandala save budget
                    if ((e.cut_budget_type?.trim() === 'ต้นทุนขาย (COGS)' && this.inboxPermission?.toLowerCase() === 'cost') || (e.cut_budget_type?.trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && this.inboxPermission?.toLowerCase() === 'sga') || (e.cut_budget_type?.trim() === 'ต้นทุนวิจัยและพัฒนา (R&D)' && this.inboxPermission?.toLowerCase() === 'rd') && (this.selectedBiz.tax_id =='0107544000094')) {
                    // if ((e.cut_budget_type?.trim() === 'ต้นทุนขาย (COGS)' && this.inboxPermission?.toLowerCase() === 'cost') || (e.cut_budget_type?.trim() === 'ค่าใช้จ่ายขายและบริการ (SG&A)' && this.inboxPermission?.toLowerCase() === 'sga') || (e.cut_budget_type?.trim() === 'ต้นทุนวิจัยและพัฒนา (R&D)' && this.inboxPermission?.toLowerCase() === 'rd')) {
  
                    const tempData = {
                            "item_id"             : e.item_id || null,
                            "item_name"           : e.item_name || null,
                            "cut_budget_type"     : e.cut_budget_type || null,
                            "total_product_price" : e.total_product_price || null,
                            "discount"            : e.discount || null,
                            "currency_exchange"   : e.currency_exchange   || "1",
                        }
                        tempTypeBudget.push(tempData)
                    // }else if(nonCut_budget_type.includes(e.cut_budget_type) && this.inboxPermission?.toLowerCase() === 'บัญชี' && (this.selectedBiz.tax_id =='0105548134654' || this.selectedBiz.tax_id =='0105565071941')){
                    }else if(this.inboxPermission?.toLowerCase() === 'บัญชี' && this.groupBizJv){

                        const tempData = {
                            "item_id"             : e.item_id || null,
                            "item_name"           : e.item_name || null,
                            "cut_budget_type"     : e.cut_budget_type || null,
                            "total_product_price" : e.total_product_price || null,
                            "discount"            : e.discount || null,
                            "currency_exchange"   : e.currency_exchange   || "1",
                        }
                        tempTypeBudget.push(tempData)
                    }
                })
                //mandala save budget
                let convertedTypeBudget;
                if (this.inboxPermission?.toLowerCase() === 'บัญชี'){
                    const originalTypeBudget = this.transactionDetail?.products?.find(e => e.cut_budget_type);
                        if (originalTypeBudget.cut_budget_type === 'ต้นทุนขาย (COGS)') {
                            convertedTypeBudget = 'COST';
                        } else if (originalTypeBudget.cut_budget_type === 'ต้นทุนวิจัยและพัฒนา (R&D)') {
                            convertedTypeBudget = 'RD';
                        }else if (originalTypeBudget.cut_budget_type == 'ค่าใช้จ่ายขายและบริการ (SG&A)') {
                            convertedTypeBudget = 'SGA'  
                        } else {
                            convertedTypeBudget = '';
                        } 
                }
                const tempSaveBudget = {
                    "products"                   : tempTypeBudget,
                    "transaction_id"             : this.transactionId                                                                                                       || null,
                    //mandala save budget                                                                                 || null,
                    "type_budget"                : this.inboxPermission?.toLowerCase() === 'บัญชี' ? convertedTypeBudget : this.inboxPermission                               || null,
                    // "type_budget"                : this.inboxPermission,
                    "formData"                   : 'purchase_detail',
                    "tax_id"                     : this.selectedBiz?.tax_id                                                                                                 || null,
                    "end_date"                   : this.transactionDetail?.end_date                                                                                         || null,
                    "document_year"              : this.transactionDetail?.document_year                                                                                    || null,
                    "start_date"                 : this.transactionDetail?.start_date                                                                                       || null,
                    "total_price"                : this.transactionDetail?.total_price                                                                                      || null,
                    "document_status"            : this.transactionDetail?.is_save_budget_retrospect ? 'W' : this.transactionDetail?.document_status                        || null,
                    "in_budget"                  : typeof this.transactionDetail?.has_memo === 'boolean'? (!this.transactionDetail?.has_memo? true : this.transactionDetail.memo.in_budget) : false,
                    "document_status_permission" : this.transactionDetail?.flow_step?.find(e => e?.inbox === this.inboxPermission)?.status                                  || null,
                    // "save_budget_id"             : this.transactionDetail?.save_budget?.find(e => e?.type_budget.toLowerCase() === this.inboxPermission.toLowerCase())?._id || null,
                    "save_budget_id"             : this.inboxPermission?.toLowerCase() === 'บัญชี' ? this.transactionDetail?.save_budget[0]?._id : this.transactionDetail?.save_budget?.find(e => e?.type_budget.toLowerCase() === this.inboxPermission.toLowerCase())?._id || null,
                    "save_budget" : this.transactionDetail.save_budget || null,
                }                   
                EventBus.$emit('openSaveBudgetStatus',this.iconSuccess)
                EventBus.$emit('openSaveBudgetModal', tempSaveBudget)
            },
            typingMemoEvent(memo_no) {
                if (!memo_no) {
                    return
                }
                this.getMemoNumber = {}
                this.$set(this.purchaseData, 'in_budget'        , null)
                this.$set(this.purchaseData, 'memo_budget'      , null)
                this.$set(this.purchaseData, 'remaining_budget' , null)
                clearTimeout(this.typingTimeout)
                this.typingTimeout = setTimeout(() => {
                    this.getMemoDetail(memo_no)

                }, 1000)
            },
            editAndResendFn() {
                this.resendStatus = true
                this.isReady      = false
                if (this.transactionDetail?.has_memo && this.transactionDetail?.memo_id && this.transactionDetail?.memo_no) {
                    this.getMemoDetail(this.transactionDetail.memo_no)
                }
                this.autoFillAndGetDropdown()
            },
            async getMemoDetail(memo_no) {
                if (!memo_no) {
                    return
                }
                try {
                    const { data } = await this.axios.get(`${this.$api_url}/memo_budget/api/v1/check_memo?tax_id=${this.selectedBiz.tax_id || ''}&memo_no=${encodeURIComponent(memo_no)}`)
                    if (data.status && Object.keys(data.data)?.length) {
                        this.getMemoNumber             = data.data
                        this.purchaseData.in_budget    = data.data.in_budget
                        this.purchaseData.memo_budget  = MainFunction.addComma(Number(data.data?.remaining_budget?.replace(/,/g, '') || "0").toFixed(2))
                        if (this.isSameAllCurrency && this.purchaseData.has_memo) {
                            this.noneCalCurrencyExchange = ( data.data?.currency && data.data?.currency !== 'บาท' ) ? true : false
                            this.purchaseData.remaining_budget = MainFunction.addComma((Number(data.data?.remaining_budget?.replace(/,/g, '') || '0') - (Number(this.purchaseData.total_price?.replace(/,/g, '')) * (this.noneCalCurrencyExchange ? 1 : this.purchaseData.currency_exchange) || 0)).toFixed(2))
                        }
                    }
                } catch (error) {
                    console.log(error)
                }
            },
            alert(title = '', text = '', icon = 'info') {
                this.$swal({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    icon: icon,
                    title: `<b class="alert-success-title">${title}</b>`,
                    text:  text,
                    showClass: {
                        popup: 'animate-show-card'
                    },
                    customClass: {
                        container: 'alert-card-block',
                        popup: 'alert-card-success',
                        title: 'alert-title-block',
                        htmlContainer: 'alert-text-box',
                        icon: 'alert-icon'
                    }
                });
            },
            async getDocumentStatusDWF() {
                const { data } = await this.axios.get(`${this.$api_url}/transaction/api/v1/document_status_dwf?transaction_id=${this.transactionId || ''}`)
                if (data.status && data.data) this.document_status_dwf = data.data
            },
            deleteProduct(index) {
                this.$nextTick(() => {
                    this.$delete(this.purchaseData.products, index);
                    this.calculateCost(
                        this.purchaseData.products[this.purchaseData.products.length - 1]
                    );
                    this.$nextTick(() => {
                        this.$refs.boarderForm?.resetValidation();
                    });
                    this.getShowRowSignNo4()
                });
            },
            receiveProductData(data) {
                this.$nextTick(() => {
                const { index, product } = data;
                    this.purchaseData.products[index] = { ...product };
                    this.calculateCost();
                });
            },
            connectSomeProductData(product) {
                if (this.transactionId && !this.resendStatus) {
                    this.$set(this.transactionDetail.products[0], "vendor", product.vendor);
                    this.$set(
                        this.transactionDetail.products[0],
                        "budget_type",
                        product.budget_type
                    );
                } else {
                    this.$set(this.purchaseData.products[0], "vendor", product.vendor);
                    this.$set(
                        this.purchaseData.products[0],
                        "budget_type",
                        product.budget_type
                    );
                }
                this.$forceUpdate()
            },
            memoData(selectedItem) {
                const selectedMemo = this.memoList.find(memo => memo.memo_no === selectedItem);
                this.noneCalCurrencyExchange = (selectedMemo?.currency && selectedMemo?.currency !== 'บาท') ? true : false
                if (selectedMemo) {
                    this.purchaseData.memo_id = selectedMemo._id
                    this.purchaseData.in_budget = selectedMemo.in_budget
                    this.purchaseDataMeMo = selectedMemo;
                    this.purchaseData.memo_budget = MainFunction.addComma(Number(selectedMemo.remaining_budget|| '0.00').toFixed(2))
                    this.purchaseData.memo_currency = selectedMemo?.currency || 'บาท'
                    this.calculateCost();}
            },
            downloadFile() {
                const link = document.createElement('a');
                link.href = '/file/คู่มือการเพิ่มและดูเอกสารMEMO.pdf'; // Path relative to the public directory
                link.download = 'คู่มือการเพิ่มและดูเอกสารMEMO.pdf'; // Adjust the download file name as necessary
                link.click();
                this.alert('ดาวน์โหลดคู่มือสำเร็จ', 'Success', 'success');
            },
            async getShowRowSignNo2(){
                const { data } = await this.axios.get(`${this.$api_url}/transaction/api/v1/permission_transaction?tax_id=${this.selectedBiz.tax_id}`)
                if (data.status && data.data)
                this.permissionShowRowSignNo2 = data.data.permission
                if(this.selectedBiz.tax_id === '0107544000094') 
                    for (let i = 0; i < this.purchaseData.products.length; i++) {
                        this.purchaseData.products[i] =
                        this.$refs.ProductsCard[i].setDefaultData(this.purchaseData.requirement);
                }
                this.getShowRowSignNo4()
            },
            async handleRequestGlAccount({ index, product }) {
                if (
                !product?.item?.material_code ||
                !product?.vendor?.vendor_code ||
                !product?.cost_center?.costcenter_code ||
                this.selectedBiz?.tax_id !== '0107544000094'
                ) {
                return;
                }
                try {
                const { data } = await this.axios.get(
                    `${this.$api_url}/item_erp/api/v1/search_gl_account`,
                    {
                    params: {
                        material_code: product.item.material_code,
                        tax_id: this.selectedBiz.tax_id,
                        vendor_code: product.vendor.vendor_code,
                        costcenter_code: product.cost_center.costcenter_code,
                    },
                    }
                );
                const glAccount = data?.data?.gl_code_new;
                if (!glAccount) return;
                this.$set(
                    this.purchaseData.products[index].item,
                    'gl_account',
                    glAccount
                );

                } catch (e) {
                console.error(e);
                }
            },
          }  
        }
</script>

<style>
    
    .div-create-detail {
        margin: 60px 8% 4% 8%;
    }

    .div-create-detail-1 {
        margin: 20px 1% 4% 1%;
    }

    .div-create-detail-2 {
        margin: 20px 8% 4% 8%;
    }

    .div-check-document {
        margin: 20px 3% 4% 0%;
    }

    .div-check-document-1 {
        margin: 0% 8% 4% 8%;
    }

    .external-card-detail {
        height: 100%;
        border-radius: 23px !important;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        background-color: white;
    }

    .external-card-detail-1 {
        height: 100%;
        border-radius: 23px !important;
        background-color: white;
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
    }

    .border-radius-box {
        border-radius: 5px;
        font-size: 16px;
    }

    .border-radius-box > .v-input__control > .v-input__slot {
        min-height: 0px;
    }

    .border-radius-box.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
        padding: 0px;
    }

    .border-radius-box > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details {
        padding: 0px;
    }

    .border-radius-box > .v-input__control > .v-input__slot > .v-text-field__slot input {
        margin-left: 10px;
        /* margin-right: 10px; */
    }

    .in-budget-memo-input > .v-input__control > .v-input__slot > .v-text-field__slot input {
        margin-top: 3px;
    }

    .border-radius-box input {
        line-height: 30px;
    }

    .border-radius-box fieldset {
        border-color: 1px solid #A8A8A8;
    }

    .border-radius-box.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: 31px;
    }

    .font-create-header {
        font-size: calc(100% + 1.5vw);
        font-weight: 400;
    }

    .create-purchase-padding {
        padding-left: 5%;
        padding-right: 5%;
    }

    .margin-checkbox .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }

    .text-field-right .v-input__control .v-input__slot .v-text-field__slot input {
        text-align: right !important;
    }

    .product-list-row:nth-of-type(even) .v-expansion-panels .v-expansion-panel {
        background: #FFFFFF !important;
        border-radius: 0px;
    }

    .product-list-row:nth-of-type(odd) .v-expansion-panels .v-expansion-panel {
        background: rgba(239, 239, 239, 0.47) !important;
        border-radius: 0px;
    }

    .product-list-row .v-expansion-panels .v-expansion-panel::before {
        box-shadow: none;
    }

    .list-product-card {
        padding: 2% 4% 0% 4%;
    }

    .director-card {
        padding: 18px 4% 0% 4%;
    }

    .browse-file-approve-doc-btn {
        margin-top: 36px !important;
        padding-right: 3.8%;
        padding-bottom: 35px;
    }

    .browse-file-btn:not(.v-btn--round).v-size--default{
        min-width: auto;
    }

    .detail-dropdown.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control > .v-input__slot {
        min-height: auto !important;
    }

    .detail-dropdown fieldset {
        border: 1px solid #A8A8A8;
    }

    .detail-dropdown .v-input__icon {
        margin-top: 4px;
    }

    .detail-dropdown.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot {
        padding: 0px;
    }

    .detail-dropdown.v-select.v-input--dense .v-select__selection--comma  {
        margin-left: 10px;
        margin-right: 10px;
    }

    .detail-dropdown.v-application--is-ltr .v-text-field .v-input__append-inner {
        margin-left: 0px !important;
        padding-left: 0px !important;
    }
    
    .detail-dropdown.v-text-field.v-input--dense .v-input__prepend-inner, .v-text-field.v-input--dense .v-input__append-inner {
        margin-top: 0px !important;
    }

    .detail-dropdown .v-select__selections {
        line-height: 30px
    }

    .margin-left-text-field .v-input__control .v-input__slot .v-text-field__slot input {
        margin-left: 10px;
        margin-right: 10px;
    }

    .v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) .v-text-field__prefix, .v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) .v-text-field__suffix, .v-textarea.v-text-field--box.v-text-field--single-line:not(.v-input--dense) textarea, .v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) .v-text-field__prefix, .v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) .v-text-field__suffix, .v-textarea.v-text-field--box.v-text-field--outlined:not(.v-input--dense) textarea, .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) .v-text-field__prefix, .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) .v-text-field__suffix, .v-textarea.v-text-field--enclosed.v-text-field--single-line:not(.v-input--dense) textarea, .v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) .v-text-field__prefix, .v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) .v-text-field__suffix, .v-textarea.v-text-field--enclosed.v-text-field--outlined:not(.v-input--dense) textarea {
        margin-top: 0px;
        margin-left: 10px;
        margin-right: 10px;
    }

    .detail-date-picker-create-purchase .theme--light.v-date-picker-table th {
        color: black !important;
        background-color: #E3E3E35E !important;
        font-size: 16px !important;
    }

    .detail-date-picker-create-purchase .v-picker__body .v-date-picker-table table {
        border-spacing: 0 !important;
    }

    .detail-dropdown.v-select.v-text-field:not(.v-text-field--single-line) input {
        margin-left: 10px !important;
        line-height: 30px;
        /* margin-right: 10px !important; */
    }

    .v-select .vs__selected-options {
        flex-wrap: nowrap;
    }

    .detail-dropdown .v-input__control .v-input__slot  .v-select__slot .v-select__selections {
        height: 31px;
        margin-top: -16px;
    }

    .budget_type-cost-center-detail-dropdown .v-input__control .v-input__slot  .v-select__slot .v-select__selections {
        height: 31px;
        margin-top: 0px;
    }

    .clear-icon-margin .v-input__control .v-input__slot .v-input__append-inner .v-input__icon--clear {
        margin-top: 3px !important;
    }

    .comment-box-detail {
        font-size: 16px !important;
        border: 1px solid #000000;
    }

    .comment-box-detail .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar {
        width: 12px;
    }

    .comment-box-detail .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .comment-box-detail .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .comment-box-detail .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #eaf1f6;
    }

    .comment-box-detail .v-input__control .v-input__slot .v-input__prepend-inner {
        margin-top: 5px;
        margin-left: 5px;
    }

    .comment-box-detail .v-input__control .v-input__slot {
        padding: 0px !important;
    }

    .text-area-description .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar {
        width: 12px;
    }

    .text-area-description .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .text-area-description .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar {
        width: 8px;
        background-color: transparent !important;
    }

    .text-area-description .v-input__control .v-input__slot .v-text-field__slot textarea::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #eaf1f6;
    }

    .text-area-description .v-input__control .v-input__slot .v-input__prepend-inner {
        margin-top: 5px;
        margin-left: 5px;
    }

    .text-area-description .v-input__control .v-input__slot {
        padding: 0px !important;
    }

    .theme--light.time-line-detail::before {
        background: #AEAEAE;
        width: 1.5px;
    }

    .v-timeline::before {
        width: 1px
    }

    .vendor-filled-margin-create .v-input__control .v-input__slot .v-select__slot {
        margin: 0 10px;
    }

    .vendor-filled-margin-create .v-input__control .v-input__slot .v-select__slot .v-input__append-inner {
        margin-right: -10px
    }

    .radio-memo-create .v-input--selection-controls__input {
        margin-right: 0px;
    }

    .radio-memo-create .v-input--selection-controls__input .v-icon {
        font-size: 17px;
    }

    .fade-left-to-right {
        opacity: 0;
        transform: translateX(-20px);
        animation: fadeLeftToRight 0.3s ease-out forwards;
    }

    .border-radius-box .v-input__control .v-input__slot .v-input__append-inner {
        margin-top: 0px;
        padding-left: 0px;
    }

    .total-value-pr-create-doc .v-input__control .v-input__slot .v-text-field__slot input {
        max-height: 64px;
    }

    .red-text {
      color: red;
      font-family: 'Noto Sans Thai', sans-serif !important;
    }

    .custom-row-serial-num{
        justify-content: flex-end;
    }

    .field-serial-num .v-label{
        top: 50%;
        left: 10px !important;
        transform: translateY(-50%);
        font-size: 12px;
    }

    @keyframes fadeLeftToRight {
        from {
            opacity: 0;
            transform: translateX(-20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    @media only screen and (max-width: 959px){ /*css for mobile screen*/

        .list-product-card {
            padding-top: unset !important
        }

        .list-product-card {
            padding-top: unset !important
        }

        .director-card {
            padding: 0% 4% 0% 4%;
        }

        .custom-serial-num {
            flex: 0 0 65.2%;
            max-width: 65.2%;
        }
    }
    @media only screen and (max-width: 725px) {
        .custom-title-license{
            flex: 0 0 100%;
            max-width: 100%
        }
        .custom-row-license,
        .custom-row-serial-num{
            justify-content: center;
        }
        /* .custom-layout-license{
            flex: 0 0 60%;
            max-width: 60%
        }
        .custom-serial-num {
            flex: 0 0 60%;
            max-width: 60%
        }   */
    }
    @media only screen and (max-width: 599px) {
        .custom-serial-num {
            flex: 0 0 100%;
            max-width: 100%
        }       
    }
    @media only screen and (max-width: 292px) {
        .custom-layout {
            flex: 0 0 100%;
            max-width: 100%;
        }
        .renew-checkbox.v-input--selection-controls { 
            margin-top: 0;
        }
    }

</style>